var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.149,
    height: 100.434,
    viewBox: "0 0 130.149 100.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518",
    transform: "translate(19477.001 307.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514",
    transform: "translate(-19367.686 -249.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M404.323,392.493l-.014,0h-.027l.024.044C404.312,392.522,404.317,392.508,404.323,392.493Z",
    transform: "translate(-387.225 -379.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M402.627,399.649h0l-.01-.01-.008.023Z",
    transform: "translate(-386.317 -383.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M394.81,389.465a2.267,2.267,0,0,0,1.179,1c.139-.011.162-.131.215-.225a6.891,6.891,0,0,0,.319-.974c.149-.387.251-.792.383-1.187a.5.5,0,0,0-.057-.473c-.363-.565-.667-1.162-.99-1.75-.246-.448-.522-.882-.769-1.33-.063-.114-.161-.224-.1-.391.125.017.168.113.218.206.452.826.9,1.653,1.36,2.475.134.242.285.474.433.719a.6.6,0,0,0,.241-.393c.154-.513.275-1.037.448-1.544.311-.913.562-1.847.881-2.755a.943.943,0,0,0-.145-.985c-.556-.8-1.059-1.645-1.584-2.471a.472.472,0,0,1-.04-.062c-.028-.062-.1-.138-.013-.189s.136.041.171.1c.255.4.513.806.753,1.217.306.524.71.982,1.025,1.587a.155.155,0,0,0,.026,0l.014,0c.117-.314.224-.556.291-.807.255-.955.552-1.9.858-2.838.256-.789.473-1.59.746-2.374.142-.411.272-.83.389-1.252a.4.4,0,0,1,.24-.323,1.724,1.724,0,0,1-.187.75c-.32.985-.64,1.967-.913,2.966a3.929,3.929,0,0,1-.167.407.115.115,0,0,0,.018.136c.044.042.091.018.133-.006.294-.179.627-.273.921-.454a5.959,5.959,0,0,1,.608-.285.159.159,0,0,1-.112.219,12.313,12.313,0,0,0-1.493.781.543.543,0,0,0-.268.322c-.328,1.086-.667,2.168-.977,3.259-.15.524-.318,1.051-.5,1.57-.131.369-.241.748-.382,1.2l.01.01h0c1.165-.787,2.305-1.479,3.448-2.175a.136.136,0,0,1-.062.212q-.99.629-1.986,1.248a11.906,11.906,0,0,0-1.4.949,1.331,1.331,0,0,0-.356.748c-.219.866-.543,1.7-.8,2.552-.121.4-.241.794-.368,1.189-.052.163-.117.321-.177.482a2.255,2.255,0,0,0,.878.036,3.457,3.457,0,0,0,1.37-.365,5.389,5.389,0,0,0,1.662-1.479,9.877,9.877,0,0,0,1.249-2.187,6.325,6.325,0,0,0,.482-1.382q.215-1.022.349-2.059a20.022,20.022,0,0,0,.23-2.666c0-.573-.008-1.147-.025-1.719-.027-.9-.142-1.8-.188-2.7a23.743,23.743,0,0,0-.259-2.442c-.054-.348-.119-.386-.425-.232a3.128,3.128,0,0,0-.438.269c-.295.213-.581.438-.873.656a13.956,13.956,0,0,0-2.65,2.47,16.213,16.213,0,0,0-2.255,3.713,17.075,17.075,0,0,0-1.1,3.527,15.1,15.1,0,0,0-.227,1.892,8.124,8.124,0,0,0,.146,2.011A4.55,4.55,0,0,0,394.81,389.465Z",
    transform: "translate(-381.678 -369.414)",
    fill: "#02bb8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M401.158,403.111c.051-.162.1-.326.148-.49-.043.146-.089.291-.133.437C401.169,403.076,401.163,403.094,401.158,403.111Z",
    transform: "translate(-385.529 -385.365)",
    fill: "#c5e2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M406.95,385.09c-.092.051-.185.106-.282.034a.168.168,0,0,1-.076-.156q-.144.463-.293.924A1.585,1.585,0,0,1,406.95,385.09Z",
    transform: "translate(-388.32 -375.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M399.018,409.759c.024-.081.051-.162.076-.243a2.613,2.613,0,0,0-.133.459C398.986,409.9,399,409.824,399.018,409.759Z",
    transform: "translate(-384.336 -389.108)",
    fill: "#c5e2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M408.831,384.378c-.163.083-.339.171-.522.26.027-.01.051-.023.079-.032A2.384,2.384,0,0,0,408.831,384.378Z",
    transform: "translate(-389.411 -375.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M404.146,393.495c-.063.2-.124.4-.188.606.056-.169.111-.338.166-.508A.671.671,0,0,0,404.146,393.495Z",
    transform: "translate(-387.049 -380.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M406.091,386.989a2.673,2.673,0,0,0-.1.292c-.025.091-.051.183-.076.274.039-.13.078-.261.119-.39C406.055,387.106,406.072,387.047,406.091,386.989Z",
    transform: "translate(-388.112 -376.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M409.45,384.22c.091-.048.181-.092.261-.133A1.389,1.389,0,0,0,409.45,384.22Z",
    transform: "translate(-390.03 -375.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M407.991,384.947a1.794,1.794,0,0,0-.268.132c.019-.01.038-.021.057-.029Z",
    transform: "translate(-389.093 -375.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M399.874,403.875a.85.85,0,0,0,.123.188c-.066-.106-.132-.211-.2-.317Z",
    transform: "translate(-384.793 -385.976)",
    fill: "#c5e2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M407,384.274a.969.969,0,0,0-.065.214c.043-.135.084-.269.126-.405C407.046,384.146,407.027,384.21,407,384.274Z",
    transform: "translate(-388.668 -375.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M399.866,404.141a.2.2,0,0,1-.167-.055c.011.017.021.034.032.052a.57.57,0,0,1,.08.52c-.186.582-.378,1.163-.559,1.749.029-.083.059-.165.084-.248.234-.8.522-1.579.774-2.371-.009.026-.018.052-.03.077C400.029,403.974,400.011,404.124,399.866,404.141Z",
    transform: "translate(-384.494 -385.998)",
    fill: "#c5e2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M407.216,381.114c.27-.829.518-1.667.78-2.5C407.73,379.446,407.474,380.281,407.216,381.114Z",
    transform: "translate(-388.818 -372.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M398.527,401.473c-.36-.636-.712-1.278-1.074-1.914C397.81,400.2,398.149,400.846,398.527,401.473Z",
    transform: "translate(-383.518 -383.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M396.851,398.525c-.164-.293-.331-.585-.507-.87C396.517,397.943,396.685,398.234,396.851,398.525Z",
    transform: "translate(-382.916 -382.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M401.482,401.575c.089-.294.178-.587.27-.881a1.251,1.251,0,0,0-.109.285C401.594,401.179,401.539,401.378,401.482,401.575Z",
    transform: "translate(-385.705 -384.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M401.178,387.981c-.114-.184-.216-.349-.3-.488C400.955,387.627,401.059,387.794,401.178,387.981Z",
    transform: "translate(-385.377 -377.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M404.082,390.214a.532.532,0,0,1,.1.421c.248-.8.486-1.6.707-2.408-.171.573-.323,1.152-.53,1.714-.037.1-.055.219-.176.236-.006.015-.011.029-.016.045l-.024-.044a.184.184,0,0,1-.122-.06C404.037,390.151,404.06,390.182,404.082,390.214Z",
    transform: "translate(-387.08 -377.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M403.742,391.966a.79.79,0,0,0,.1.135l-.15-.22Z",
    transform: "translate(-386.902 -379.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M402.519,390.079c-.353-.554-.711-1.093-.984-1.519C401.806,388.994,402.149,389.532,402.519,390.079Z",
    transform: "translate(-385.734 -377.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M403.22,399.116c.085-.06.17-.118.255-.176-.165.1-.334.205-.487.325.037-.021.073-.052.107-.073S403.18,399.145,403.22,399.116Z",
    transform: "translate(-386.522 -383.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M398.275,410.7c.086.1.2.052.3.057a1.049,1.049,0,0,1,.011-.241A.251.251,0,0,1,398.275,410.7Z",
    transform: "translate(-383.964 -389.653)",
    fill: "#c5e2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M402.295,399.161c-.075.233-.15.467-.223.7a1.48,1.48,0,0,1,.418-.477.128.128,0,0,1-.154.005l-.018.012.008-.023A.2.2,0,0,1,402.295,399.161Z",
    transform: "translate(-386.025 -383.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M406.217,396.628c.485-.292.933-.554,1.27-.79C407.167,396.051,406.712,396.323,406.217,396.628Z",
    transform: "translate(-388.275 -381.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M402.858,395.888q.172-.532.341-1.068-.324.99-.639,1.981c.009-.026.019-.052.027-.075C402.695,396.452,402.767,396.168,402.858,395.888Z",
    transform: "translate(-386.29 -381.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M405.042,397.566c-.321.194-.658.4-.989.628l.1-.067C404.454,397.932,404.755,397.744,405.042,397.566Z",
    transform: "translate(-387.101 -382.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M397.378,397.273a2.6,2.6,0,0,1,.133-.459c.181-.586.373-1.167.559-1.749a.57.57,0,0,0-.08-.52c-.011-.017-.021-.035-.032-.052a.847.847,0,0,1-.123-.188l-.072-.129c-.378-.627-.717-1.274-1.074-1.914-.166-.292-.334-.583-.507-.87.176.285.343.577.507.87.362.636.714,1.278,1.074,1.914.064.107.129.212.2.317a.2.2,0,0,0,.167.055c.145-.017.163-.167.214-.276.012-.026.021-.051.03-.077s.009-.029.014-.043.011-.035.016-.053c.043-.146.089-.291.133-.437.057-.2.112-.4.161-.6a1.247,1.247,0,0,1,.109-.285c.073-.234.148-.468.223-.7v0q.316-.992.639-1.981c.064-.2.125-.4.188-.606a.532.532,0,0,0-.1-.421c-.022-.032-.044-.064-.066-.1a.794.794,0,0,1-.1-.135l-.055-.085c-.369-.547-.713-1.085-.984-1.519-.119-.187-.224-.354-.3-.488.084.138.187.3.3.488.273.426.63.965.984,1.519l.15.22a.184.184,0,0,0,.122.06c-.314-.605-.719-1.063-1.024-1.587-.24-.411-.5-.814-.753-1.217-.035-.057-.09-.145-.171-.1s-.016.127.013.189a.483.483,0,0,0,.04.062c.525.826,1.028,1.667,1.584,2.471a.943.943,0,0,1,.145.985c-.319.908-.57,1.841-.881,2.755-.172.507-.294,1.03-.448,1.544a.6.6,0,0,1-.241.393c-.148-.245-.3-.477-.433-.719-.457-.822-.907-1.649-1.36-2.475-.05-.093-.093-.189-.218-.206-.059.167.04.277.1.391.248.448.524.883.769,1.33.323.588.628,1.185.99,1.75a.5.5,0,0,1,.057.473c-.132.395-.234.8-.383,1.187a6.876,6.876,0,0,1-.32.974c-.053.094-.077.213-.215.225A.251.251,0,0,0,397.378,397.273Z",
    transform: "translate(-382.754 -376.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M402.559,399.157v0Z",
    transform: "translate(-386.29 -383.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M403.543,383.239c.207-.562.359-1.141.53-1.714.025-.09.052-.182.076-.274a2.679,2.679,0,0,1,.1-.292q.15-.461.293-.924a.971.971,0,0,1,.065-.214c.022-.064.041-.127.061-.192.258-.832.514-1.667.78-2.5.1-.309.2-.618.3-.926-.1.308-.2.617-.3.926-.262.833-.51,1.67-.78,2.5-.042.136-.084.27-.126.405a.168.168,0,0,0,.076.156c.1.071.19.017.282-.034a1.776,1.776,0,0,1,.268-.132c.182-.089.358-.177.522-.26a1.388,1.388,0,0,1,.262-.133c-.081.041-.17.085-.262.133a2.377,2.377,0,0,1-.443.228c-.028.01-.053.022-.079.032l-.211.1c-.02.009-.038.02-.057.029a1.584,1.584,0,0,0-.65.8c-.019.058-.037.117-.056.176-.042.129-.08.26-.119.39-.222.806-.459,1.609-.707,2.408a.668.668,0,0,1-.022.1c-.055.17-.11.339-.166.508q-.169.536-.341,1.068c-.09.28-.163.564-.271.837-.009.023-.019.049-.027.075v0a.2.2,0,0,0,.031.218c.141-.448.25-.827.382-1.2.184-.518.352-1.046.5-1.57.31-1.092.649-2.173.977-3.26a.544.544,0,0,1,.268-.322,12.336,12.336,0,0,1,1.493-.781.159.159,0,0,0,.111-.218,6,6,0,0,0-.608.285c-.294.181-.628.275-.921.454-.042.025-.089.048-.133.006a.116.116,0,0,1-.018-.136,3.925,3.925,0,0,0,.167-.407c.272-1,.592-1.981.913-2.966a1.722,1.722,0,0,0,.187-.75.4.4,0,0,0-.24.323c-.118.421-.247.841-.39,1.252-.273.784-.49,1.585-.746,2.374-.305.939-.6,1.883-.858,2.838-.067.251-.174.492-.291.807C403.488,383.458,403.505,383.34,403.543,383.239Z",
    transform: "translate(-386.269 -370.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M399.476,400.614c.259-.853.582-1.686.8-2.552a1.33,1.33,0,0,1,.356-.748,11.908,11.908,0,0,1,1.4-.949q1-.619,1.986-1.248a.136.136,0,0,0,.062-.212c-1.142.7-2.282,1.388-3.448,2.175a.128.128,0,0,0,.155-.005c.154-.119.323-.221.487-.325.331-.225.668-.434.989-.628.495-.305.949-.577,1.27-.79-.337.236-.785.5-1.27.79-.288.178-.588.366-.886.561l-.1.067c-.085.057-.17.116-.255.176-.039.029-.084.051-.125.076s-.071.051-.107.073a1.479,1.479,0,0,0-.418.477c-.092.293-.181.587-.27.881-.048.164-.1.328-.148.49-.005.015-.009.028-.014.043-.252.791-.54,1.573-.774,2.371-.025.083-.054.165-.084.248s-.052.161-.076.243c-.021.065-.032.144-.058.216a1.05,1.05,0,0,0-.011.241c.059-.16.125-.319.177-.482C399.236,401.407,399.356,401.011,399.476,400.614Z",
    transform: "translate(-384.319 -381.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M392.408,384.838h-.016c0,.008,0,.016,0,.026Z",
    transform: "translate(-380.77 -375.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M382.255,370.01a8.217,8.217,0,0,0,.493,2.251c.143.382.289.763.433,1.144-.176-.129-.379-.165-.535-.285a.908.908,0,0,0-.527-.143c-.292-.015-.489.231-.542.626a4.248,4.248,0,0,0,.159,1.663,10.176,10.176,0,0,0,1.021,2.393.3.3,0,0,1,.046.281,2.082,2.082,0,0,0-1-.6.794.794,0,0,0-1.05.47,2.546,2.546,0,0,0,0,1.83c.236.759.517,1.506.79,2.254.315.862.642,1.721.969,2.578a5.775,5.775,0,0,0,1.067,1.918c.473.514.782.589,1.336.353a2.4,2.4,0,0,0,1.038-.8c-.025-.779-.059-1.559-.067-2.34a.554.554,0,0,0-.188-.447c-.559-.513-1.089-1.059-1.668-1.549-.627-.533-1.173-1.142-1.76-1.711a3.173,3.173,0,0,0-.582-.55.072.072,0,0,1-.018-.122.1.1,0,0,1,.133-.027,1.314,1.314,0,0,1,.23.181c.878.96,1.83,1.843,2.792,2.715.316.286.632.572.98.884a1.643,1.643,0,0,0,.038-.521c-.006-.622-.023-1.244-.027-1.866,0-.46,0-.92,0-1.381a.749.749,0,0,0-.18-.469c-.872-1.133-1.782-2.234-2.714-3.318-.211-.244-.39-.515-.59-.782.149-.079.2.017.262.087.257.312.51.626.763.941.336.418.7.81,1.037,1.232.361.455.742.9,1.088,1.364a.94.94,0,0,0,.266.272,1.871,1.871,0,0,0,.056-.609c-.014-.546,0-1.093-.005-1.64s0-1.121,0-1.683a.517.517,0,0,0-.089-.311c-.384-.534-.761-1.075-1.142-1.612-.432-.61-.913-1.182-1.37-1.772a.409.409,0,0,1-.127-.353,7.048,7.048,0,0,1,.923,1.093c.3.374.607.739.875,1.133s.555.773.861,1.154a18.272,18.272,0,0,0,.006-1.958c-.011-.66-.022-1.32-.009-1.979s.015-1.316.017-1.974a9.515,9.515,0,0,1,.066-1.942c.177,2.61.017,5.227.168,7.913H386a36.4,36.4,0,0,1,2.872-4.12.941.941,0,0,1-.252.526c-.465.626-.913,1.262-1.341,1.914-.4.612-.754,1.251-1.171,1.851a.659.659,0,0,0-.136.373c0,.331-.008.661-.005.99,0,.462.012.925.016,1.387,0,.5,0,1,0,1.5a.358.358,0,0,0,.07.249c.72-.881,1.338-1.823,2.005-2.725s1.392-1.748,2.04-2.662c.139.089.069.169.025.231-.253.342-.51.682-.769,1.021-.708.931-1.437,1.846-2.089,2.82a12.365,12.365,0,0,1-.919,1.229,1.643,1.643,0,0,0-.377,1.213c.028.94.027,1.882.037,2.822a.5.5,0,0,0,.124.425c.538-.534,1.019-1.116,1.52-1.68s.985-1.148,1.477-1.723.907-1.188,1.44-1.776a.371.371,0,0,1-.1.358c-.522.645-1.013,1.314-1.562,1.939-.586.668-1.14,1.366-1.739,2.021-.312.342-.6.709-.935,1.03a.532.532,0,0,0-.182.422c.016.623.025,1.245.041,1.869a.325.325,0,0,0,.083.271h0c.53-.507,1.034-1.039,1.54-1.57a17.533,17.533,0,0,0,1.172-1.358,22.848,22.848,0,0,0,1.494-2.125,9.083,9.083,0,0,0,.878-1.812,3.583,3.583,0,0,0,.188-1.043.606.606,0,0,0-.365-.587,1.1,1.1,0,0,0-.755-.074c-.353.08-.705.172-1.071.264a.587.587,0,0,1,.117-.357q.408-.609.761-1.252a7.214,7.214,0,0,0,.794-1.964,2.162,2.162,0,0,0,.007-1.017.477.477,0,0,0-.624-.393,2.612,2.612,0,0,0-.938.408,3.019,3.019,0,0,1-.581.347.254.254,0,0,1,.032-.2,20.366,20.366,0,0,0,.751-2.11,6.013,6.013,0,0,0,.227-1.371.56.56,0,0,0-.83-.581,2.339,2.339,0,0,0-.362.178,4.561,4.561,0,0,0-1.066.974c-.024-.03-.051-.048-.052-.067,0-.232-.013-.464,0-.7a10.474,10.474,0,0,0-.369-3.447,1.8,1.8,0,0,0-.464-.78.952.952,0,0,0-1.087-.181,2.14,2.14,0,0,0-.716.613,4.074,4.074,0,0,0-.683,1.526,10.463,10.463,0,0,0-.3,2.5c0,.138.106.28,0,.431-.134-.057-.184-.177-.268-.261a1.657,1.657,0,0,0-.726-.484.458.458,0,0,0-.623.421A1.79,1.79,0,0,0,382.255,370.01Z",
    transform: "translate(-374.362 -364.874)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M390.967,383.923c.034.048.069.1.1.145.056.082.111.207.2.245a1.748,1.748,0,0,0-.277-.36Z",
    transform: "translate(-379.997 -375.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M392.4,410.234q0,.026,0,.052a.623.623,0,0,1-.059.283.356.356,0,0,0,.218-.165h0A.175.175,0,0,1,392.4,410.234Z",
    transform: "translate(-380.742 -389.498)",
    fill: "#f1befe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M391.885,375.528c-.078-1.456-.062-2.911-.052-4.366.008-.986,0-1.974-.036-2.959.062,1.66.012,3.32.021,4.981,0,.733.028,1.467.04,2.2,0,.144.053.335-.106.394a.155.155,0,0,1-.119,0,2.087,2.087,0,0,1,.252.874c0-.039,0-.078,0-.116a1.269,1.269,0,0,1,.223-.717c.567-.9,1.124-1.8,1.724-2.675.276-.4.575-.786.839-1.134a24.738,24.738,0,0,0-1.689,2.408c-.25.389-.508.774-.741,1.174-.059.1-.107.236-.244.215l-.016.025c0-.01,0-.018,0-.026h0C391.838,375.774,391.89,375.631,391.885,375.528Z",
    transform: "translate(-380.359 -366.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M386.543,378.073c.286.374.585.741.88,1.117q-.4-.518-.805-1.029C386.591,378.126,386.574,378.075,386.543,378.073Z",
    transform: "translate(-377.595 -372.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M392.169,397.029c0-.2,0-.4,0-.6a1.291,1.291,0,0,0-.009.461A1.351,1.351,0,0,1,392.169,397.029Z",
    transform: "translate(-380.634 -382.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M400.322,383.945c.006,0,0,.014-.011.034q-.3.405-.612.805a7.891,7.891,0,0,0,.627-.823C400.354,383.922,400.275,383.928,400.322,383.945Z",
    transform: "translate(-384.737 -375.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M393.073,393.539l.549-.758c-.144.2-.288.393-.434.589-.1.134-.2.266-.3.4.025-.027.048-.058.07-.087C393,393.636,393.037,393.59,393.073,393.539Z",
    transform: "translate(-381.041 -380.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M391.3,394.45c-.068-.089-.136-.177-.2-.264A1.106,1.106,0,0,0,391.3,394.45Z",
    transform: "translate(-380.066 -380.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M395.074,389.268q-.29.41-.585.817c.556-.757,1.105-1.517,1.668-2.27C395.788,388.3,395.422,388.775,395.074,389.268Z",
    transform: "translate(-381.909 -377.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M398.537,386.188c-.135.177-.267.355-.4.533.237-.307.477-.614.714-.922C398.745,385.926,398.638,386.055,398.537,386.188Z",
    transform: "translate(-383.889 -376.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M392.381,406.117c0-.039,0-.078,0-.117,0,.008,0,.015,0,.022C392.38,406.054,392.38,406.085,392.381,406.117Z",
    transform: "translate(-380.763 -387.199)",
    fill: "#f1befe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M392.234,400.555a.124.124,0,0,1,0-.019c-.014-.832-.019-1.663-.022-2.5,0-.1,0-.2-.009-.3,0,.912.013,1.823.024,2.734A.79.79,0,0,0,392.234,400.555Z",
    transform: "translate(-380.667 -382.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M392.42,407.923c-.006-.557-.016-1.113-.036-1.668.006.571.02,1.141.035,1.712C392.419,407.952,392.419,407.937,392.42,407.923Z",
    transform: "translate(-380.766 -387.338)",
    fill: "#f1befe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M392.271,403.9a1.053,1.053,0,0,0,.007.114A.641.641,0,0,0,392.271,403.9Z",
    transform: "translate(-380.705 -386.06)",
    fill: "#f1befe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M387.527,400.288c-.147.077-.248-.053-.346-.144-1.142-1.041-2.31-2.054-3.348-3.2-.066-.074-.135-.143-.161-.166,1.1,1.267,2.444,2.381,3.706,3.578a.789.789,0,0,1,.275.608c0,.01,0,.021,0,.031a.7.7,0,0,1,.188-.514c.139-.149.275-.3.411-.452-.051.054-.1.109-.154.161-.093.093-.172.249-.325.2a.248.248,0,0,1-.164-.241A.155.155,0,0,1,387.527,400.288Z",
    transform: "translate(-376.037 -382.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M386.638,388.736c.683.828,1.376,1.647,2.037,2.491-.005-.006-.009-.014-.014-.02C388.02,390.356,387.32,389.553,386.638,388.736Z",
    transform: "translate(-377.647 -377.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M391.724,394.6a.175.175,0,0,1-.182-.018l.11.142a.76.76,0,0,1,.189.468c0,.051,0,.1,0,.153a1.885,1.885,0,0,1,.317-.678.169.169,0,0,1-.2.064c-.114-.045-.122-.182-.118-.29a.037.037,0,0,0,0-.01A.205.205,0,0,1,391.724,394.6Z",
    transform: "translate(-380.309 -380.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M389.967,382.549a2.386,2.386,0,0,0,.263.346c-.2-.292-.409-.58-.621-.865C389.732,382.2,389.852,382.372,389.967,382.549Z",
    transform: "translate(-379.26 -374.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M392.187,392.994a1.808,1.808,0,0,0,0-.334c0-.292-.007-.584-.009-.878,0,.078,0,.155,0,.232C392.167,392.34,392.2,392.666,392.187,392.994Z",
    transform: "translate(-380.652 -379.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M388.989,381.208c-.169-.235-.345-.465-.522-.692Q388.731,380.859,388.989,381.208Z",
    transform: "translate(-378.64 -373.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M392.194,387.549a7.6,7.6,0,0,0-.008-.861q0,.5.007,1.009C392.194,387.647,392.192,387.6,392.194,387.549Z",
    transform: "translate(-380.659 -376.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M385.76,387.656c-.248-.3-.5-.6-.74-.909C385.262,387.054,385.509,387.356,385.76,387.656Z",
    transform: "translate(-376.768 -376.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M397.608,395.09c-.807,1.034-1.671,2.022-2.532,3.011-.162.185-.322.374-.484.56.844-.944,1.662-1.911,2.475-2.884C397.253,395.554,397.432,395.322,397.608,395.09Z",
    transform: "translate(-381.965 -381.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M392.191,388.894c-.008.44-.01.88-.008,1.32C392.192,389.774,392.193,389.334,392.191,388.894Z",
    transform: "translate(-380.656 -377.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M387.283,387.1c0-.017,0-.035,0-.052a.928.928,0,0,1,0-.107c-.015-.571-.028-1.141-.035-1.712,0-.032,0-.063,0-.094,0-.007,0-.015,0-.022s0-.021,0-.031a.789.789,0,0,0-.275-.608c-1.261-1.2-2.6-2.311-3.706-3.578.026.023.1.092.161.166,1.037,1.148,2.206,2.161,3.348,3.2.1.09.2.221.346.144a.154.154,0,0,0,.082-.14,1.062,1.062,0,0,1-.006-.114.789.789,0,0,1-.007-.084c-.011-.911-.021-1.822-.024-2.734,0-.044,0-.09-.011-.135a1.294,1.294,0,0,1,.009-.461c0-.052,0-.1,0-.153a.761.761,0,0,0-.189-.468l-.11-.142a1.106,1.106,0,0,1-.2-.264c-.661-.844-1.354-1.664-2.037-2.492q-.376-.45-.74-.909c.244.306.491.607.74.909.682.817,1.381,1.62,2.023,2.471.005.006.009.014.014.02.069.087.137.175.2.264a.176.176,0,0,0,.182.018.2.2,0,0,0,.12-.169c.013-.328-.02-.654-.011-.98,0-.077,0-.154,0-.232,0-.44,0-.88.008-1.32q0-.5-.007-1.008a2.087,2.087,0,0,0-.252-.874c-.091-.038-.146-.162-.2-.245-.034-.049-.069-.1-.1-.145a2.393,2.393,0,0,1-.263-.346c-.115-.177-.235-.349-.358-.519q-.258-.349-.522-.692c-.294-.376-.594-.743-.88-1.117.031,0,.047.053.074.087q.406.512.805,1.03c.177.227.353.457.522.692.212.286.418.573.621.865l.027.03a1.752,1.752,0,0,1,.277.36.154.154,0,0,0,.119,0c.158-.059.107-.249.106-.394-.012-.734-.036-1.468-.04-2.2-.008-1.661.041-3.321-.021-4.981.038.985.043,1.973.036,2.959-.011,1.455-.027,2.91.052,4.366.006.1-.047.245.095.28h0c-.151-2.686.01-5.3-.168-7.913a9.507,9.507,0,0,0-.066,1.942c0,.658,0,1.316-.017,1.974s0,1.319.009,1.979a18.264,18.264,0,0,1-.006,1.958c-.306-.381-.592-.76-.861-1.154s-.579-.758-.875-1.133a7.042,7.042,0,0,0-.922-1.094.409.409,0,0,0,.127.353c.457.59.938,1.162,1.37,1.772.381.538.757,1.078,1.142,1.612a.517.517,0,0,1,.089.311c0,.561,0,1.122,0,1.683s-.009,1.094.005,1.64a1.871,1.871,0,0,1-.056.609.938.938,0,0,1-.266-.272c-.347-.468-.728-.909-1.088-1.364-.334-.422-.7-.814-1.037-1.232-.254-.315-.506-.63-.763-.941-.058-.07-.113-.165-.262-.087.2.267.379.538.59.782.932,1.083,1.842,2.184,2.714,3.318a.749.749,0,0,1,.18.469c0,.46,0,.92,0,1.381,0,.622.021,1.244.027,1.866a1.642,1.642,0,0,1-.038.521c-.348-.312-.664-.6-.98-.884-.962-.873-1.914-1.755-2.792-2.715a1.316,1.316,0,0,0-.229-.181.1.1,0,0,0-.133.027.072.072,0,0,0,.018.122,3.169,3.169,0,0,1,.582.55c.587.57,1.133,1.178,1.76,1.711.578.49,1.109,1.036,1.668,1.549a.554.554,0,0,1,.188.447c.009.78.043,1.56.067,2.34A.622.622,0,0,0,387.283,387.1Z",
    transform: "translate(-375.626 -366.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M392.389,391.454c-.016-.624-.024-1.246-.041-1.869a.532.532,0,0,1,.182-.421c.336-.321.623-.688.935-1.03.6-.656,1.153-1.354,1.739-2.021.549-.625,1.04-1.294,1.562-1.939a.371.371,0,0,0,.1-.358c-.533.588-.954,1.209-1.44,1.776s-.974,1.158-1.477,1.723-.982,1.146-1.52,1.68a.5.5,0,0,1-.124-.425c-.01-.94-.009-1.882-.037-2.822a1.643,1.643,0,0,1,.377-1.213,12.394,12.394,0,0,0,.919-1.229c.652-.973,1.381-1.889,2.089-2.82.259-.339.516-.678.769-1.021.045-.062.114-.142-.025-.231-.647.914-1.374,1.764-2.04,2.662s-1.285,1.844-2.005,2.725a.358.358,0,0,1-.07-.249c0-.5,0-1,0-1.5,0-.462-.013-.925-.016-1.387,0-.33,0-.66.006-.99a.659.659,0,0,1,.136-.373c.417-.6.771-1.239,1.171-1.851.427-.652.876-1.288,1.341-1.914a.94.94,0,0,0,.252-.526,36.414,36.414,0,0,0-2.872,4.12c.137.021.185-.115.244-.215.234-.4.491-.785.741-1.174a24.772,24.772,0,0,1,1.689-2.408c-.264.347-.563.733-.839,1.134-.6.875-1.157,1.779-1.724,2.675a1.269,1.269,0,0,0-.223.717v.116a7.6,7.6,0,0,1,.008.861c0,.049,0,.1,0,.148,0,.44,0,.88-.008,1.32,0,.294,0,.586.009.878a1.816,1.816,0,0,1,0,.334.038.038,0,0,1,0,.01c0,.108,0,.245.118.29a.168.168,0,0,0,.2-.064c.094-.137.2-.269.3-.4.147-.2.291-.392.434-.589q.295-.408.585-.817c.348-.493.714-.973,1.083-1.452.133-.178.265-.356.4-.533.1-.132.208-.261.314-.389q.309-.4.612-.806c.015-.02.017-.032.011-.034-.047-.017.032-.023,0,.017a7.883,7.883,0,0,1-.627.823c-.237.308-.477.615-.714.922-.562.753-1.112,1.513-1.668,2.27l-.549.758c-.036.05-.076.1-.112.146-.022.03-.046.06-.07.087a1.884,1.884,0,0,0-.317.678c0,.2,0,.4,0,.6.007.1.01.2.009.3,0,.832.007,1.663.021,2.5a.124.124,0,0,0,0,.019.64.64,0,0,1,.006.114.248.248,0,0,0,.164.241c.153.048.231-.108.325-.2.053-.052.1-.107.154-.161.138-.15.276-.3.412-.451.162-.186.322-.374.484-.56.861-.989,1.725-1.977,2.532-3.011.13-.171.261-.342.393-.512-.132.169-.262.341-.393.512-.176.232-.355.464-.541.687-.813.973-1.631,1.939-2.475,2.884-.136.151-.274.3-.412.451s-.272.3-.411.452a.7.7,0,0,0-.188.514c0,.039,0,.078,0,.117.021.555.03,1.111.036,1.668,0,.014,0,.03,0,.044a.941.941,0,0,0,0,.107.174.174,0,0,0,.159.17A.325.325,0,0,1,392.389,391.454Z",
    transform: "translate(-380.657 -370.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M367.02,375.471c-.006.671-.033,1.342-.043,2.012-.007.513-.015,1.027.006,1.539.025.635.058,1.271.126,1.9.074.694.214,1.379.341,2.066a11.307,11.307,0,0,0,1.241,3.67,8.773,8.773,0,0,0,1.922,2.4,3.706,3.706,0,0,0,3.129.8c-.438-1.271-.925-2.523-1.428-3.769-.105-.261-.2-.527-.282-.8a.71.71,0,0,0-.334-.418c-.781-.48-1.58-.93-2.385-1.366a5.358,5.358,0,0,1-1.117-.734,12.852,12.852,0,0,1,1.784.915c.589.309,1.163.649,1.75.979a.287.287,0,0,0,0-.22c-.308-.8-.642-1.588-.915-2.4-.191-.567-.4-1.128-.6-1.694-.186-.529-.34-1.07-.574-1.584a.59.59,0,0,0-.338-.347c-.536-.224-1.06-.477-1.577-.751.339-.1.586.133.861.239.291.112.556.289.9.408-.533-1.448-1.05-2.853-1.582-4.293.208.025.247.165.287.278.307.875.642,1.74.971,2.606.188.491.348.992.526,1.487.216.6.432,1.2.657,1.789a10.14,10.14,0,0,0,.422,1.133.206.206,0,0,0,.114.134c.575-1,1.153-2,1.766-3.061a.38.38,0,0,1-.03.407c-.432.736-.86,1.477-1.3,2.21a4.92,4.92,0,0,1-.338.607.324.324,0,0,0-.011.346c.245.652.477,1.309.72,1.962q.459,1.236.927,2.47a1.1,1.1,0,0,0,.257.493,14.235,14.235,0,0,0,.906-1.76c.3-.579.589-1.163.916-1.811a.586.586,0,0,1-.059.506c-.477.864-.865,1.773-1.316,2.649a2.16,2.16,0,0,1-.229.414.53.53,0,0,0-.071.582q.384.99.769,1.98a.785.785,0,0,0,.213.339h0a2.282,2.282,0,0,0,1.206-1.127,4.838,4.838,0,0,0,.464-1.533,8.316,8.316,0,0,0,.04-2.193,15.16,15.16,0,0,0-1.35-4.751,17.023,17.023,0,0,0-1.894-3.142,14,14,0,0,0-1.8-1.942,23.909,23.909,0,0,0-2.742-1.976,3.687,3.687,0,0,0-.491-.247c-.144-.065-.226-.015-.261.145a6.576,6.576,0,0,0-.091.8C367.04,374.374,367.025,374.921,367.02,375.471Z",
    transform: "translate(-366.97 -369.206)",
    fill: "#24dcae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M383.149,396.866c-.094.179-.184.359-.272.539.1-.205.206-.408.308-.6C383.174,396.819,383.161,396.842,383.149,396.866Z",
    transform: "translate(-375.605 -382.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M378.222,400.035c.025.067.049.133.074.2.056.148.112.295.169.444-.062-.168-.125-.333-.185-.5C378.262,400.127,378.243,400.081,378.222,400.035Z",
    transform: "translate(-373.078 -383.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M381.794,409.428a.37.37,0,0,1-.011.289.46.46,0,0,0,.264-.07C381.9,409.638,381.839,409.536,381.794,409.428Z",
    transform: "translate(-375.011 -389.06)",
    fill: "#c6e3c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M377.409,397.854c.03.08.059.16.089.24a.942.942,0,0,0-.085-.229A.033.033,0,0,0,377.409,397.854Z",
    transform: "translate(-372.637 -382.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M383.55,396.762c.012-.022.021-.037.016-.032S383.555,396.752,383.55,396.762Z",
    transform: "translate(-375.97 -382.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M380.32,403c-.039.071-.079.143-.119.214a.544.544,0,0,0,.089-.151C380.3,403.046,380.31,403.026,380.32,403Z",
    transform: "translate(-374.152 -385.573)",
    fill: "#c6e3c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M380.732,399.83c-.084.179-.186.347-.271.525.4-.729.737-1.487,1.1-2.232C381.288,398.672,381,399.248,380.732,399.83Z",
    transform: "translate(-374.294 -382.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M375.62,393.063c.012.031.024.063.035.094l-.066-.187C375.6,393,375.608,393.031,375.62,393.063Z",
    transform: "translate(-371.649 -380.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M374.411,389.661c-.076-.218-.154-.435-.231-.653C374.255,389.227,374.33,389.445,374.411,389.661Z",
    transform: "translate(-370.884 -377.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M376.5,395.425c-.252-.683-.5-1.366-.766-2.046C375.98,394.064,376.23,394.748,376.5,395.425Z",
    transform: "translate(-371.728 -380.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M371.787,384.749a.46.46,0,0,0,.15.057c-.073-.028-.144-.059-.214-.09Z",
    transform: "translate(-369.55 -375.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M381.745,409.267c.006.016.012.031.018.046a1.019,1.019,0,0,0-.038-.1Z",
    transform: "translate(-374.98 -388.945)",
    fill: "#c6e3c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M379.3,402.915c.011.03.023.061.038.091l-.1-.248C379.262,402.812,379.281,402.863,379.3,402.915Z",
    transform: "translate(-373.632 -385.44)",
    fill: "#c6e3c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M373.56,396.638c-.12.11-.245,0-.362-.069-.966-.578-1.967-1.094-2.939-1.66,1.028.606,2.087,1.158,3.113,1.767a1.27,1.27,0,0,1,.528.576c-.094-.252-.189-.5-.283-.757A.156.156,0,0,1,373.56,396.638Z",
    transform: "translate(-368.755 -381.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M369.4,376.035q.339.875.666,1.756.368,1,.727,2c.012.031.029.065.042.1q-.433-1.19-.872-2.38C369.782,377.016,369.588,376.526,369.4,376.035Z",
    transform: "translate(-368.29 -370.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M372.354,384.481a.128.128,0,0,1-.036.164.162.162,0,0,1-.126.033l.06.025a.524.524,0,0,1,.3.348c.187.5.367,1,.546,1.5-.061-.176-.121-.352-.185-.527Z",
    transform: "translate(-369.805 -375.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M376.279,387.892a3.586,3.586,0,0,0-.21.393c.468-.816.939-1.627,1.376-2.4C377.052,386.507,376.7,387.22,376.279,387.892Z",
    transform: "translate(-371.909 -376.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M375.905,391.138c-.045.079-.092.16-.137.24v0a.534.534,0,0,0,.109-.182C375.885,391.177,375.9,391.158,375.905,391.138Z",
    transform: "translate(-371.745 -379.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M369.94,383.872c-.094-.044-.179-.083-.256-.112C369.754,383.791,369.842,383.829,369.94,383.872Z",
    transform: "translate(-368.443 -375.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M370.92,384.33c-.24-.125-.479-.238-.676-.325C370.442,384.1,370.673,384.22,370.92,384.33Z",
    transform: "translate(-368.747 -375.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M375.18,391a.19.19,0,0,1-.145.048c-.133-.011-.156-.14-.2-.239-.054-.123-.1-.247-.151-.372.118.331.234.662.353.992.021.056.04.112.06.167A.712.712,0,0,1,375.18,391Z",
    transform: "translate(-371.159 -378.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M379.726,403.5c.022-.04.044-.081.068-.122a.189.189,0,0,1-.135.07.216.216,0,0,1-.208-.149c.322.843.653,1.684.964,2.531.021.058.05.115.075.173-.269-.69-.528-1.386-.788-2.08A.472.472,0,0,1,379.726,403.5Z",
    transform: "translate(-373.745 -385.734)",
    fill: "#c6e3c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M374.692,390.853q-.385-.989-.769-1.98a.529.529,0,0,1,.071-.582,2.164,2.164,0,0,0,.229-.414c.451-.876.839-1.785,1.316-2.649a.586.586,0,0,0,.059-.506c-.327.648-.616,1.232-.916,1.811a14.243,14.243,0,0,1-.906,1.76,1.106,1.106,0,0,1-.257-.493q-.468-1.234-.927-2.47c-.242-.653-.475-1.31-.72-1.962a.324.324,0,0,1,.011-.346,4.93,4.93,0,0,0,.338-.607c.436-.734.863-1.474,1.3-2.21a.38.38,0,0,0,.03-.407c-.612,1.063-1.19,2.064-1.766,3.061a.206.206,0,0,1-.114-.134,10.108,10.108,0,0,1-.421-1.133c-.226-.593-.442-1.191-.657-1.789-.178-.494-.338-1-.526-1.487-.329-.866-.665-1.731-.971-2.606-.04-.113-.079-.253-.287-.278.531,1.441,1.048,2.845,1.582,4.293-.343-.119-.608-.3-.9-.408-.275-.106-.522-.341-.861-.239.517.274,1.04.527,1.577.751a.59.59,0,0,1,.338.347c.234.513.389,1.054.574,1.584.2.565.408,1.126.6,1.694.273.811.607,1.6.915,2.4a.287.287,0,0,1,0,.22c-.587-.33-1.161-.67-1.75-.979a12.856,12.856,0,0,0-1.784-.915,5.36,5.36,0,0,0,1.117.734c.806.437,1.6.886,2.385,1.366a.71.71,0,0,1,.334.418c.08.269.177.535.282.8.5,1.246.99,2.5,1.428,3.769a.37.37,0,0,0,.011-.288c-.006-.015-.012-.031-.018-.046l-.02-.051c-.026-.058-.055-.115-.076-.173-.311-.848-.642-1.688-.964-2.531-.014-.031-.026-.062-.038-.091-.019-.052-.038-.1-.058-.156-.076-.2-.15-.4-.223-.6-.056-.149-.113-.3-.169-.444-.025-.066-.05-.132-.075-.2a1.27,1.27,0,0,0-.528-.576c-1.026-.609-2.085-1.161-3.113-1.767.972.566,1.974,1.083,2.939,1.66.117.07.242.179.362.069a.156.156,0,0,0,.056-.144c-.03-.08-.059-.16-.089-.24-.27-.677-.519-1.361-.766-2.046-.011-.031-.023-.063-.035-.094s-.022-.064-.031-.093c-.02-.055-.04-.111-.06-.167-.118-.33-.235-.66-.352-.992-.081-.216-.156-.434-.231-.653-.179-.5-.359-1-.546-1.5a.524.524,0,0,0-.3-.348l-.06-.025a.46.46,0,0,1-.15-.057l-.064-.033c-.247-.11-.478-.23-.676-.325-.1-.044-.186-.082-.256-.112.077.028.162.068.256.112.2.087.436.2.676.325.07.031.142.062.214.09a.162.162,0,0,0,.126-.033.128.128,0,0,0,.036-.164l0-.006c-.013-.033-.03-.067-.042-.1q-.358-1-.727-2-.326-.88-.666-1.756c.187.491.381.981.564,1.474q.439,1.188.872,2.38l0,.006.562,1.543c.064.175.124.351.185.527q.117.327.231.653c.048.125.1.249.151.372.043.1.065.228.2.239a.19.19,0,0,0,.145-.048v0c.045-.08.092-.161.137-.24a3.594,3.594,0,0,1,.21-.393c.422-.672.773-1.385,1.165-2.01-.436.776-.908,1.586-1.376,2.4-.009.02-.02.039-.029.06a.536.536,0,0,1-.109.182.713.713,0,0,0-.081.6l.066.187c.263.68.514,1.363.766,2.046a.033.033,0,0,1,0,.011.941.941,0,0,1,.085.229q.141.38.283.758c.021.046.04.092.058.141.06.168.123.334.185.5.074.2.147.4.223.6l.1.248a.216.216,0,0,0,.208.149.189.189,0,0,0,.135-.07c.04-.071.08-.142.119-.213.084-.177.187-.346.271-.525.271-.582.555-1.158.833-1.707.088-.181.178-.36.272-.539.012-.024.025-.047.036-.065s.01-.021.016-.032,0,.009-.016.032c-.1.2-.2.4-.308.6-.367.745-.708,1.5-1.1,2.232-.01.021-.02.041-.03.063a.542.542,0,0,1-.089.151c-.023.041-.045.081-.068.122a.472.472,0,0,0-.024.425c.261.694.519,1.389.788,2.08a1.01,1.01,0,0,1,.038.1c.045.108.105.21.252.219h0A.786.786,0,0,1,374.692,390.853Z",
    transform: "translate(-367.869 -370.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M387.936,431.121c0,.938-4.388,1.7-9.8,1.7s-9.8-.76-9.8-1.7,4.388-1.7,9.8-1.7S387.936,430.183,387.936,431.121Z",
    transform: "translate(-367.712 -399.914)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M388.323,414.467a10.962,10.962,0,0,1-2.349,5.742,7.434,7.434,0,0,1-4.725,2.388,7.547,7.547,0,0,1-4.107-.661,5.473,5.473,0,0,1-2.815-2.837,18.214,18.214,0,0,1-1.3-4.032,5.709,5.709,0,0,1-.056-.677.626.626,0,0,1,.484-.141,19.085,19.085,0,0,1,2.642.028c1.146.09,2.3.125,3.441.111,1.562-.019,3.125-.014,4.686,0,1.216.008,2.429-.014,3.644-.03A.616.616,0,0,1,388.323,414.467Z",
    transform: "translate(-370.228 -391.659)",
    fill: "#62c0c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M388.138,409.969c-1.925.112-3.853.054-5.779.049-.828,0-1.657.021-2.486.008-1.641-.026-3.28-.053-4.92-.172-.718-.053-1.445.021-2.167.037a7.986,7.986,0,0,1-.116-2.5c.02-.979.041-.979,1.013-1.053a1.079,1.079,0,0,0,.117-.022l3.771-.134a.342.342,0,0,1,.345-.021l.15.037c1.479-.006,2.95-.208,4.43-.184a.276.276,0,0,1,.391-.015q1.552-.053,3.1.005a3.147,3.147,0,0,0,.947.042,6.786,6.786,0,0,1,1.081.056c.144.013.266.026.268.216A18.5,18.5,0,0,1,388.138,409.969Z",
    transform: "translate(-370.042 -387.161)",
    fill: "#18888c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M127.845,439.414c0,2.854,24.034,5.168,53.68,5.168s53.68-2.314,53.68-5.168-24.033-5.168-53.68-5.168S127.845,436.56,127.845,439.414Z",
    transform: "translate(-19604.846 -651.826)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M207.255,334.748l.013-.014v0c.006.006.013.01.02.017h-.032Z",
    transform: "translate(-19647.953 -597.804)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M257.156,441.687l-.219-.071A1.318,1.318,0,0,1,257.156,441.687Z",
    transform: "translate(-19674.922 -655.827)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M213.569,428.507l-.145.1c.025-.036.05-.071.074-.11.024,0,.047.011.071.011Z",
    transform: "translate(-19651.303 -648.705)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M255.3,299.389a20.834,20.834,0,0,0-5.376,4.079c-3.223,3.2-5.915,6.864-9.184,10.01a4.172,4.172,0,0,1-2.258,1.268,1.2,1.2,0,0,0-.121,0c-1.79.106-1.954.393-1.019,1.892,1.047,1.68,2.128,3.34,3.182,5.017.2.315.354.646.8.632a.994.994,0,0,0,.167.877c.534.728,1.024,1.49,1.531,2.239h0a32.042,32.042,0,0,1-.463,4.173,20.511,20.511,0,0,1-3.646,2.191l-.414.485h0c-.453-.432-.726-1.1-1.473-1.153-.35-1.225-1.429-1.927-2.11-2.918-.406-.59-.992-1.053-1.408-1.659-.184-.267-.414-.664-.874-.347h0c-.093-.293.054-.675-.339-.871-.311,0-.317.288-.408.484-1.307,2.787-2.629,5.568-3.891,8.375a2.075,2.075,0,0,1-1.445,1.3v0h0c-.839-.331-1.673-.68-2.521-.985-.747-.269-1.313-.918-2.144-1h0a5.251,5.251,0,0,0-1.456-.828c-.684-.4-.8-.627-.511-1.382.4-1.051.861-2.084,1.329-3.109a3.881,3.881,0,0,0,.434-1.736c.386-.157.313-.463.249-.767.7-.549.74-1.386.933-2.155.295-.19.214-.518.288-.789a2.513,2.513,0,0,0,.674-1.647c0-.1.009-.2.013-.3a39.581,39.581,0,0,0,1.621-4.14.542.542,0,0,0-.214-.638,11.735,11.735,0,0,1-1.219-2.462h0c.011-.6.05-1.21.026-1.812a3.264,3.264,0,0,1,.942-2.405,34.565,34.565,0,0,1,5.1-4.416c1.717-1.257,3.446-2.5,5.169-3.749a52.431,52.431,0,0,1,7.452,2.057c.539.165,1.088.308,1.62.5.549.194.737-.089.821-.553a1.81,1.81,0,0,0,.046-.359c-.043-1.619.192-3.221.287-4.831.059-.981.028-1.02-.986-1.014-.736,0-1.435-.216-2.162-.24-.641-.021-.928-.4-.979-1.008a5.131,5.131,0,0,0-.244-1.909h0a9.287,9.287,0,0,0-.315-3.346c.088-1.123.116-1.164,1.146-1.243,1.4-.108,2.795-.229,4.195-.288a1.164,1.164,0,0,0,1.278-.975c.086.245-.069.63.331.692s.378-.327.493-.564a6.941,6.941,0,0,0,.341-2.138c.227-1.516.543-3.013.87-4.5a19.721,19.721,0,0,0,.172-2.653c.036-.429-.144-.9.229-1.272v1.219c.34-.033.289-.278.341-.428q1.7-4.843,3.388-9.694a7.613,7.613,0,0,1,1.448-2.494,1.17,1.17,0,0,1,1.146-.515h0a6.523,6.523,0,0,0,3.084,2.611c.182.087.356.193.542.272a10.53,10.53,0,0,1,5.518,5.208c1.071,2.179,2.262,4.328,2.469,6.792.156,1.849.128,3.718.107,5.577-.033,2.906.792,5.656,1.43,8.442a8.38,8.38,0,0,1-2.437.69A49.165,49.165,0,0,0,255.3,299.389Z",
    transform: "translate(-19654.744 -560.256)",
    fill: "#626ea3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M288.083,351.552h0a1.048,1.048,0,0,0-1.087.23.243.243,0,0,1-.15,0h0a16.877,16.877,0,0,0-3.509-.133c-4.015.034-8.015-.219-12.012-.542-1.329-.107-2.651-.3-3.976-.461a.337.337,0,0,0-.5-.145h0l-.975-.063c-1.015-.28-2.034-.546-3.043-.844a2.813,2.813,0,0,1-1.891-1.353c2.123-.288,3.216-2.014,4.422-3.428,2.55-2.988,5.2-5.879,7.919-8.709a18.539,18.539,0,0,1,6.4-4.112,53.447,53.447,0,0,1,10.475-3.467c.549-.105,1.262-.055,1.517-.792,1.589-.282,3.175-.589,4.769-.84,2.613-.411,3.656.676,3.195,3.264a93.949,93.949,0,0,1-2.76,9.794,28.375,28.375,0,0,1-3.158,6.929c-1.26,2.048-2.753,3.79-5.176,4.48l-.457.194Z",
    transform: "translate(-19677.098 -593.502)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M290.023,329.619a53.445,53.445,0,0,0-10.475,3.467,18.537,18.537,0,0,0-6.4,4.113c-2.715,2.83-5.369,5.721-7.919,8.709-1.206,1.414-2.3,3.14-4.422,3.428a2.257,2.257,0,0,1-.111-.246,4.172,4.172,0,0,0,2.258-1.268c3.269-3.147,5.961-6.814,9.184-10.01a20.835,20.835,0,0,1,5.376-4.079,49.166,49.166,0,0,1,11.588-4.215,8.38,8.38,0,0,0,2.437-.69C291.284,329.564,290.572,329.514,290.023,329.619Z",
    transform: "translate(-19676.965 -594.599)",
    fill: "#fdd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M174.876,280.391h0a15.283,15.283,0,0,0,.472,4.445,15.07,15.07,0,0,0,.347,3.8,3.908,3.908,0,0,1,.092,1.067h0c-1.97-1.168-4.066-.733-6.119-.394a6.9,6.9,0,0,0-2.7.56c-.1.434.3.49.544.668a48.534,48.534,0,0,1,5.4,4.448h0a1.845,1.845,0,0,0-.4.259,2.705,2.705,0,0,1-2.258.87,2.753,2.753,0,0,0-3.268.8,12.526,12.526,0,0,1-1.766,1.259,3.08,3.08,0,0,1-1.867.319c-.562.018-1.152-.082-1.36.671-.082.3-.379.24-.613.24q-3.566,0-7.132,0a4.141,4.141,0,0,1-.441-1.992,8.226,8.226,0,0,1,1.413-4.322c1.017-1.519,2.207-2.9,3.312-4.346a24.508,24.508,0,0,1,3.48-3.713,16.465,16.465,0,0,0,2.117-2,18.12,18.12,0,0,1,7.829-5.742C173.468,277.817,173.877,279.382,174.876,280.391Z",
    transform: "translate(-19618.938 -566.623)",
    fill: "#495381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M157.416,378.071l.718-.243c.548.035.426-.553.709-.765.051.6.485.575.884.484,1.526-.35,3.069-.588,4.621-.785.754-.1,1.5-.313,2.255-.344s.858-.4.779-1a.462.462,0,0,0,.22-.4,42.02,42.02,0,0,0-.013-5.207,1.339,1.339,0,0,1-.043-.234c.239-3.394-.406-6.765-.239-10.163a65.364,65.364,0,0,0,.021-6.792c-.166-3.03-.181-6.057-.174-9.088a3.542,3.542,0,0,1,.146-1.554c.2-.441-.137-.654-.415-.883.579-.079.51-.52.511-.919q.008-2.838.013-5.677h0c1.4-.07,2.8-.155,4.2-.2.374-.012.792-.144,1.12.179v0l-.013.014c-.432,0-.864-.015-1.3,0-.807.028-.91.1-.831.939a23.866,23.866,0,0,1,.214,2.754c-.026,1.369,0,2.737.009,4.106a34.522,34.522,0,0,0-.084,6.4c.093,2.788.041,5.58.057,8.37q.036,6.368.08,12.737h0c-.089,1.724-.2,3.449-.257,5.175-.031,1.015.038,1.1.986,1.366,1.006.285,2.031.5,3.046.746a2.885,2.885,0,0,0,.969.251c-.024.039-.049.074-.074.11l-3.032,2.072a5.493,5.493,0,0,0-3.725-.551,5,5,0,0,0-1.538.923c-2.72,1.889-5.522,3.683-7.738,6.2a1.594,1.594,0,0,1-.268.247,1.127,1.127,0,0,1-1.448-.014c-.478-.416-.335-.869-.064-1.307a5.486,5.486,0,0,1,1.052-1.327c.8-.685,1.626-1.332,2.394-2.046a11.836,11.836,0,0,0,2.32-2.094,8.809,8.809,0,0,0-1.309.011c-1.151.2-2.287.515-3.444.631-.612.061-.794.424-1.053.81.082-.547-.3-.388-.6-.413-.582-.049-.315.418-.421.656a.862.862,0,0,0-.992-.486c-2.313.556-4.707.673-7,1.31a6.249,6.249,0,0,0-2.638,1.143,1.28,1.28,0,0,1-.915.236c-.577,0-1.172.012-1.452-.627-.165-.381.225-.906.916-1.267a9.829,9.829,0,0,1,2.146-.815c3.046-.778,6.08-1.6,9.135-2.344a1.264,1.264,0,0,0,1.022-.845C156.912,377.88,157.005,378.14,157.416,378.071Z",
    transform: "translate(-19613.412 -597.549)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M257.189,406.8a2.324,2.324,0,0,1-1.3-2.763c.214-1.011.434-2.023.651-3.035h0a.435.435,0,0,0,.218-.521c.021-.149.04-.3.059-.446a.706.706,0,0,0,.189-.761.237.237,0,0,1,.031-.213.711.711,0,0,0,.192-.8l.068-.418a.7.7,0,0,0,.2-.758.238.238,0,0,1,.034-.216.711.711,0,0,0,.19-.794c.02-.141.04-.283.061-.423.275-.213.239-.5.185-.789-.074-.3.3-.548.14-.856a1.225,1.225,0,0,0,.526-.3c.064.334-.33.678-.125,1.01-.018.15-.037.3-.056.449-.269.21-.235.492-.183.779-.02.146-.04.292-.059.438a.7.7,0,0,0-.19.768.211.211,0,0,1-.032.206c-.282.208-.254.493-.2.785-.021.144-.043.289-.063.432a.7.7,0,0,0-.192.762.224.224,0,0,1-.03.211c-.285.219-.25.512-.188.811-.019.135-.037.271-.056.406-.332.28-.244.65-.213,1.006q.1.355.2.707a3.182,3.182,0,0,0-.608,2.776c.151.725.855.908,1.468,1.078a1.022,1.022,0,0,0,1.252-.662c.178-.343.6-.546.595-1.005.508-.2.5-.683.57-1.109q.46-2.61.911-5.22c.064-.1.189-.2.185-.3-.095-2.22.577-4.38.517-6.6.083-.1.167-.187.243-.29a14.083,14.083,0,0,0,.5-3.775,4.279,4.279,0,0,0-.229-.59c.309-1.835.612-3.669.935-5.5.123-.7.284-1.39.435-2.084h.027a2.111,2.111,0,0,1,.465.114,31.655,31.655,0,0,0-.675,4.129,26.921,26.921,0,0,1-.5,2.955c-.331.3-.23.672-.183,1.037q0,.431-.006.861a13.934,13.934,0,0,0-.294,2.858c-.058,1.231-.384,2.457-.37,3.682.016,1.382-.648,2.641-.557,4.014-.084.979-.168,1.957-.263,3.068.9-.858.965-1.973,1.481-2.857.611.033,1.105.654,1.825.25a3.187,3.187,0,0,0,1.5-1.642,9.184,9.184,0,0,0,.314-1.153c.111-.448.265-.85.8-.919,1.242,1.039,2.728,1.754,3.9,2.891,2.726,2.657,2.555,2.9-.063,5.268a8.914,8.914,0,0,1-1.923,1.269c-.3.155-.608.295-.859-.062-.3-.432-.559-.3-.875.005-.527.5-1.091.965-1.634,1.453-.05.044-.053.14-.1.275a1.91,1.91,0,0,0,.912.11c4.084.222,8.167.478,12.253.63,3,.113,6,.09,8.994.121,1.661.017,3.321.02,4.982.034a4.118,4.118,0,0,0,1.553-.231c1.1-.43,1.413-1.007.962-2.073-.693-1.64-1.388-3.286-2.211-4.862-2.212-4.236-4.207-8.575-6.258-12.888-.99-2.083-1.921-4.195-2.874-6.3a2.183,2.183,0,0,1-.3-.761,1.936,1.936,0,0,0,.32-.063,45.119,45.119,0,0,1,3.122,6.175c2.2,4.645,4.377,9.3,6.73,13.876a29.158,29.158,0,0,1,2.114,4.769c.469,1.536.186,2-1.354,2.733a4.325,4.325,0,0,1-1.9.342c-5.387-.069-10.778-.062-16.16-.32-3.478-.168-6.95-.467-10.434-.511-1.6-.02-1.6-.014-3.027,1.354a49.092,49.092,0,0,1,8.181.58c3.884.37,7.775.2,11.653.457,3.971.258,7.941.128,11.91.1a13.6,13.6,0,0,0,2.987-.508,1.488,1.488,0,0,0,1.248-1.8,6.625,6.625,0,0,0-1.022-2.961c-2.922-5.1-5.412-10.422-8.273-15.55q-2.248-4.032-4.473-8.079c-.151-.275-.442-.528-.4-.878.017,0,.034-.006.051-.006a.524.524,0,0,0,.465-.4q2.312,4.188,4.624,8.375c2.94,5.321,5.512,10.836,8.6,16.077a7.659,7.659,0,0,1,1.1,3.191,2.31,2.31,0,0,1-1.83,2.742,12.056,12.056,0,0,1-3.707.57c-4.253-.122-8.506-.021-12.764-.191-5.387-.216-10.767-.4-16.129-.971a13.45,13.45,0,0,0-3.755,0,11.783,11.783,0,0,1-2.885.159c-1.557-.1-1.815-.4-1.776-1.92C257.892,407.148,257.892,407.148,257.189,406.8Z",
    transform: "translate(-19674.314 -621.948)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M270.08,396.1h0c.017-.1.033-.2.051-.3a4.273,4.273,0,0,1,.229.59,14.081,14.081,0,0,1-.5,3.775c-.076.1-.16.195-.243.29,0-.06,0-.12,0-.181A32.037,32.037,0,0,0,270.08,396.1Z",
    transform: "translate(-19681.807 -630.955)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M260.736,410.862h0l.414-.485a.431.431,0,0,1,.15.254,1.226,1.226,0,0,1-.526.3.382.382,0,0,0-.038-.069Z",
    transform: "translate(-19676.986 -638.869)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M320.242,380.912c-.017,0-.033.005-.051.006a.66.66,0,0,1,.058-.211h0l.457-.194A.524.524,0,0,1,320.242,380.912Z",
    transform: "translate(-19709.262 -622.657)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M273.8,378.566a.337.337,0,0,1,.5.144c-.026.077-.045.155-.068.233a2.11,2.11,0,0,0-.465-.114h-.027c.019-.087.039-.174.058-.262Z",
    transform: "translate(-19684.045 -621.57)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M317.566,381.43a.244.244,0,0,0,.15,0c.046.065.088.133.132.2a1.951,1.951,0,0,1-.32.063.682.682,0,0,1,.038-.266Z",
    transform: "translate(-19707.814 -623.155)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M139.313,326.2c1.974-.153,3.938-.436,5.923-.437a1.223,1.223,0,0,0,.656.187,1.928,1.928,0,0,0,.789.107q2.786.019,5.571,0a.521.521,0,0,0,.24-.016l.021-.011c4.424-.028,8.842-.428,13.261-.267,6.342.23,12.685.361,19.029.488a8,8,0,0,0,1.814-.066c1.422.7,3,.485,4.5.765.384.071.822-.115,1.141.249-.005.322-.008.644-.016.966-.035,1.222-.441,1.691-1.679,1.691a38.8,38.8,0,0,1-5.537-.145.7.7,0,0,0-.568.123l-4.412-.122h0a26.686,26.686,0,0,0-5.9.131c-1.489.064-2.978-.326-4.468,0l-.07.023h0c-.007-.007-.014-.011-.02-.017-.028-.511-.462-.542-.779-.533a17.133,17.133,0,0,0-4.587.484c-.015.02-.025.041-.038.061a3.307,3.307,0,0,0-1.125.025l-11.285-.2h0a50.329,50.329,0,0,0-8.235.069,18.015,18.015,0,0,1-4.233-.069c-1.331-.27-1.762-1.085-1.265-2.377A1.422,1.422,0,0,1,139.313,326.2Z",
    transform: "translate(-19610.266 -592.912)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    "data-name": "Path 6608",
    d: "M155.984,326.219c.971.015,1.944-.023,2.912.022,1.062.05,2.125.059,3.187.052l-.021.011a.52.52,0,0,1-.24.016q-2.785.021-5.571,0a1.926,1.926,0,0,1-.789-.107C155.636,326.222,155.811,326.216,155.984,326.219Z",
    transform: "translate(-19619.836 -593.181)",
    fill: "#fdd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    d: "M199.744,333.918c-1.4.046-2.8.131-4.2.2h0l-.086-.011c.014-.02.023-.041.038-.061a17.137,17.137,0,0,1,4.587-.484c.317-.008.751.022.779.534C200.536,333.774,200.118,333.906,199.744,333.918Z",
    transform: "translate(-19641.551 -597.17)",
    fill: "#fdd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6610",
    "data-name": "Path 6610",
    d: "M229.713,295.942a3.729,3.729,0,0,0-2.337-2.534c-.826-.237-1.712-.514-2.4.347h0a4.913,4.913,0,0,1-1.756-.736c-1.909-.943-2.763-.98-4.406,1.257l-.089-.007h0q-.545-5.33-1.094-10.659a4.12,4.12,0,0,0-.144-.575q-.019-.951-.038-1.9a20.708,20.708,0,0,0,1.024-3.94h0c1.142.259,2.282.528,3.427.776,1.855.4,3.716.776,5.566,1.2a1.717,1.717,0,0,1,1.617,1.816,4.888,4.888,0,0,1,.013.728,2.419,2.419,0,0,0,.658,1.888,1.953,1.953,0,0,1,.47,2.016,3.947,3.947,0,0,0,.092,2.152,23.774,23.774,0,0,0,.849,2.269c.723,1.757,1.7,3.4,2.317,5.2h0A6.833,6.833,0,0,0,229.713,295.942Z",
    transform: "translate(-19653.484 -566.569)",
    fill: "#495381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    d: "M177.2,334.921h.116a7.116,7.116,0,0,1-.821,3.5,3.378,3.378,0,0,0-.437,1.742,1.042,1.042,0,0,0-.572.75,3.453,3.453,0,0,1-2.064,2.389,3.448,3.448,0,0,0-2.018,2.668,12.544,12.544,0,0,1-.95,2.869c-.328.721,0,1.008.524,1.3-.8.084-.8.084-1.032,1.291h0c-.139.243-.294.48-.414.732a19.812,19.812,0,0,1-3.849,5.125,1.011,1.011,0,0,1-1.192.348c-.383-.173-.382-.589-.378-.959.006-.527,0-1.054.041-1.579a51.463,51.463,0,0,0,.208-5.7,16.57,16.57,0,0,1,1.1-6.9,10.061,10.061,0,0,0,.835-4.978c-.128-1.046-.233-2.09-.263-3.142a9.148,9.148,0,0,0,3.554.531C172.119,335.014,174.659,334.993,177.2,334.921Z",
    transform: "translate(-19624.531 -597.615)",
    fill: "#495381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    "data-name": "Path 6612",
    d: "M179.6,334.577c0,.115,0,.23,0,.343h-.116c-2.538.072-5.078.093-7.612-.008a9.15,9.15,0,0,1-3.554-.531h0Z",
    transform: "translate(-19626.814 -597.614)",
    fill: "#495381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    d: "M272.431,251.118a11.522,11.522,0,0,1-2.033-.652,1.261,1.261,0,0,1-.847-1.449,1.806,1.806,0,0,0-.32-1.5,1.254,1.254,0,0,0-1.263-.535,1.1,1.1,0,0,0-.886.889,6.136,6.136,0,0,0-.183.945c-.029.393-.091.743-.552.811-.48.071-1,.173-1.282-.384a8.72,8.72,0,0,1-.877-1.993c-.044-.2-.092-.392-.154-.584-.391-1.212-.842-1.506-2.056-1.322a7.124,7.124,0,0,0-1.3.258,2.5,2.5,0,0,1-1.768-.112h0a2.086,2.086,0,0,1-.644-1.637,6.449,6.449,0,0,1,1.074-3.308,7,7,0,0,1,6.453-3.37c.323.023.646.044.97.051,3.393.074,5.5,2.006,6.984,4.834a1.835,1.835,0,0,1,.184.7c.155,2.05.3,4.1.441,6.153h0A5.6,5.6,0,0,0,272.431,251.118Z",
    transform: "translate(-19675.639 -544.837)",
    fill: "#936347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M201.09,428.274l.145-.1h0l1.147-.291c.891.005,1.328.644,1.77,1.272a4.253,4.253,0,0,0,2.568,1.858c.994.225,1.361.094,1.806-.845.18-.382.362-.5.727-.3l.474.745a8.481,8.481,0,0,1,.262,2.662c-.018.607-.01,1.215-.063,1.818-.043.489-.144.98-.757,1.1-2.108.41-4.218.884-6.356.192a3.514,3.514,0,0,0-1.434-.132,35.2,35.2,0,0,1-8.111-.372,3.7,3.7,0,0,1-1.6-.534c-.512-.345-1.04-.7-.957-1.423.075-.656.614-.9,1.143-1.136a4.64,4.64,0,0,1,1.536-.336,7.8,7.8,0,0,0,4.667-2.106A4.921,4.921,0,0,0,201.09,428.274Z",
    transform: "translate(-19638.969 -648.373)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M206.792,430.809l3.032-2.072A4.921,4.921,0,0,1,206.792,430.809Z",
    transform: "translate(-19647.701 -648.836)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M261.025,255.907c.521-.069,1.032-.206,1.551-.285,1.117-.169,1.565.08,1.909,1.171a12.793,12.793,0,0,0,.925,2.238,1.325,1.325,0,0,0,1.371.794,1.21,1.21,0,0,0,1.135-1.078,5.049,5.049,0,0,1,.162-.584c.159-.436.372-.855.913-.827.579.031.8.463.919.973.538,2.352.763,2.56,3.1,2.9.043-.032.081-.066.123-.1-.654,1.817-1.44,3.585-1.978,5.444a.7.7,0,0,1-.674.583,5.673,5.673,0,0,0-.936.221,6.3,6.3,0,0,0-1.98.5c-1.884.433-2.739.142-3.778-1.511a11.909,11.909,0,0,0-1.956-2.448,3.344,3.344,0,0,1-1.1-2.224,30.98,30.98,0,0,0-.826-4.382,4.79,4.79,0,0,1-.268-1.9h0A1.25,1.25,0,0,0,261.025,255.907Z",
    transform: "translate(-19676.377 -554.734)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M261.443,255.269a7.124,7.124,0,0,1,1.3-.258c1.214-.184,1.665.11,2.056,1.322.062.192.11.389.154.584a8.724,8.724,0,0,0,.877,1.993c.284.557.8.455,1.282.384.461-.068.523-.418.552-.811a6.141,6.141,0,0,1,.183-.945,1.1,1.1,0,0,1,.886-.889,1.254,1.254,0,0,1,1.263.535,1.807,1.807,0,0,1,.32,1.5,1.261,1.261,0,0,0,.847,1.449,11.523,11.523,0,0,0,2.033.652c-.011.032-.024.064-.036.1-.042.032-.08.067-.123.1-2.334-.339-2.56-.547-3.1-2.9-.118-.511-.341-.943-.919-.973-.541-.028-.754.391-.913.827a5.06,5.06,0,0,0-.162.584,1.21,1.21,0,0,1-1.135,1.078,1.325,1.325,0,0,1-1.371-.794,12.8,12.8,0,0,1-.925-2.238c-.345-1.09-.793-1.34-1.909-1.171-.519.079-1.03.216-1.551.285a1.25,1.25,0,0,1-1.383-.517h0A2.5,2.5,0,0,0,261.443,255.269Z",
    transform: "translate(-19676.41 -554.501)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M203.233,273.806c-1.545,1.857-3.744,2.028-5.74.383a17.219,17.219,0,0,0-1.733-1.456,11.472,11.472,0,0,0-1.752-2.715,1.381,1.381,0,0,0-1.394-.529,12.465,12.465,0,0,1-.578-1.194c-.2-.537-.37-1.1.276-1.5a1.2,1.2,0,0,1,.981.63.658.658,0,0,0,.828.32c.375-.126.418-.462.409-.8a10.751,10.751,0,0,0-.069-1.209c-.19-1.341.507-2.038,1.779-1.724a4.761,4.761,0,0,0,3.419-.369,11.288,11.288,0,0,1,1.206-.575,1.5,1.5,0,0,1,2.219,1.121c.089.508.237.963.9.913h0c.2,1.446.524,2.874.6,4.337h0a15.093,15.093,0,0,0-1.335,4C203.241,273.564,203.236,273.685,203.233,273.806Z",
    transform: "translate(-19639.594 -558.821)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M194.908,277.782a11.472,11.472,0,0,1,1.752,2.715c-.075-.048-.145-.1-.224-.144h0c-1-1.009-1.408-2.574-2.92-3.1A1.381,1.381,0,0,1,194.908,277.782Z",
    transform: "translate(-19640.492 -566.584)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M216.744,281.556c0-.121.007-.242.01-.363a15.093,15.093,0,0,1,1.335-4,20.711,20.711,0,0,1-1.024,3.94C216.961,281.285,216.853,281.424,216.744,281.556Z",
    transform: "translate(-19653.104 -566.571)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    d: "M200.385,255.377a7.764,7.764,0,0,1-4.906.827c-.935-.168-1.648.644-1.693,1.641-.015.324.08.641.086.964.016.943-.172,1.067-.992.637-.292-.154-.556-.347-.885-.107a16.329,16.329,0,0,1-.7-4.749,5.439,5.439,0,0,1,3.885-4.992,8.347,8.347,0,0,1,4.892-.1,4.421,4.421,0,0,1,3.48,3.357,11.116,11.116,0,0,1,.109,4.79h0a4.668,4.668,0,0,1-.637-1.162C202.451,255.26,201.575,254.808,200.385,255.377Z",
    transform: "translate(-19639.277 -551.364)",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M203.625,263.8a1.5,1.5,0,0,0-2.219-1.121,11.29,11.29,0,0,0-1.206.575,4.76,4.76,0,0,1-3.419.369c-1.272-.314-1.969.383-1.779,1.724a10.758,10.758,0,0,1,.069,1.209c.009.335-.033.671-.409.8a.658.658,0,0,1-.828-.32,1.2,1.2,0,0,0-.982-.63c.329-.241.593-.048.885.106.821.43,1.008.305.992-.637-.005-.323-.1-.64-.086-.964.046-1,.758-1.809,1.693-1.641a7.764,7.764,0,0,0,4.906-.827c1.19-.569,2.066-.117,2.642,1.111a4.668,4.668,0,0,0,.637,1.162C203.862,264.766,203.714,264.312,203.625,263.8Z",
    transform: "translate(-19640.133 -558.431)",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M178.685,316.307c-.565,1.1-.238,1.634.99,1.631,2.352,0,4.705-.025,7.056.043,1.008.03,2.013.189,3.029.159.447-.014.909.034,1.157-.467a58.735,58.735,0,0,1,8.588-.223h0c.485,0,.971,0,1.456-.01.877-.026,1.22-.332,1.372-1.2.3-1.687-.482-2.686-2.263-2.928a2.877,2.877,0,0,1,3.639,1.476,2.1,2.1,0,0,0,.572.762,1.881,1.881,0,0,0-.4,1.991c.141.513.33,1.012.511,1.514a8.337,8.337,0,0,0-1.307-.057c-5.071.171-10.141-.092-15.2-.317-5.727-.255-11.411.006-17.116.308,1.783-.863,4.009-.654,5.5-2.216a3.069,3.069,0,0,1,2.872-.986A1.5,1.5,0,0,0,178.685,316.307Z",
    transform: "translate(-19628.15 -586.08)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M154.027,325.729l.341-.065a.724.724,0,0,0,.084.09C154.31,325.744,154.168,325.74,154.027,325.729Z",
    transform: "translate(-19619.057 -592.882)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M162.518,321.23c.208-.753.8-.653,1.36-.671a3.079,3.079,0,0,0,1.867-.319,12.526,12.526,0,0,0,1.766-1.259,2.754,2.754,0,0,1,3.268-.8h0a3.3,3.3,0,0,0-.32.213,3.069,3.069,0,0,0-2.872.986c-1.49,1.563-3.716,1.354-5.5,2.216h0a57.318,57.318,0,0,1-7.226-.036.723.723,0,0,1-.084-.09q3.566,0,7.132,0C162.138,321.47,162.435,321.528,162.518,321.23Z",
    transform: "translate(-19619.465 -588.693)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M154.683,325.992a1.224,1.224,0,0,1-.656-.187c.141.011.283.016.425.025A.766.766,0,0,0,154.683,325.992Z",
    transform: "translate(-19619.057 -592.959)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M187.439,325.144c5.055.225,10.126.489,15.2.317a8.344,8.344,0,0,1,1.307.057c.036.1.071.194.105.292a8,8,0,0,1-1.814.066c-6.344-.127-12.687-.257-19.029-.488-4.419-.161-8.837.239-13.261.267q.186-.111.378-.2C176.027,325.15,181.712,324.889,187.439,325.144Z",
    transform: "translate(-19627.697 -592.544)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M154.956,325.861a57.306,57.306,0,0,0,7.226.036h0q-.193.093-.379.2c-1.062.007-2.124,0-3.187-.052-.969-.046-1.941-.008-2.912-.022-.172,0-.348,0-.521,0A.766.766,0,0,1,154.956,325.861Z",
    transform: "translate(-19619.564 -592.989)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M237.981,314.249a2.877,2.877,0,0,0-3.639-1.476c-.138-.019-.282-.035-.432-.044h0c.692-.861,1.579-.584,2.4-.347a3.729,3.729,0,0,1,2.336,2.534c-.036.031-.064.064-.1.1A2.1,2.1,0,0,1,237.981,314.249Z",
    transform: "translate(-19662.424 -585.543)",
    fill: "#e7e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M240.97,429.815a2.5,2.5,0,0,1-1.3-.812,9.921,9.921,0,0,1-.027-4.163c.175-.581.384-1.172,1.173-1.146a3.422,3.422,0,0,0,2.165.5,2.255,2.255,0,0,1,.946.04,2.064,2.064,0,0,0,2.479-.526,1.933,1.933,0,0,1,1.017.916c.035.085.069.171.1.256-.043.145-.092.288-.144.432a17,17,0,0,0-.633,2.579,2.8,2.8,0,0,0,1.115,3.19.981.981,0,0,1,.482.911l-.7-.031a1.314,1.314,0,0,0-.218-.071C245.276,431.192,243.126,430.491,240.97,429.815Z",
    transform: "translate(-19665.416 -646.097)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M256.457,432.483a2.8,2.8,0,0,1-1.115-3.19,17.006,17.006,0,0,1,.633-2.579c.052-.144.1-.287.144-.432q.057.138.113.277c-.217,1.012-.437,2.024-.651,3.035a2.323,2.323,0,0,0,1.3,2.763c.7.346.7.346.054,1.037A.981.981,0,0,0,256.457,432.483Z",
    transform: "translate(-19674.008 -647.503)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M253.893,321.482c.007.053.02.106.029.159a6.384,6.384,0,0,1-2.5.393,3.034,3.034,0,0,0-1.463.16c-.3-.48-.819-.461-1.307-.528a31.3,31.3,0,0,1-4.331-.63.583.583,0,0,0-.043-.425,4.494,4.494,0,0,1-.258-3.1.461.461,0,0,0,.039.026,25.022,25.022,0,0,0,3.758-.87h0a7.233,7.233,0,0,0,4.649,1.254,5.579,5.579,0,0,1,1.407.261h0A13.714,13.714,0,0,0,253.893,321.482Z",
    transform: "translate(-19667.826 -587.997)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M265.935,323.324h0c-.089.042-.179.079-.269.115-.009-.053-.022-.106-.029-.159a13.709,13.709,0,0,1-.016-3.3h0A9.289,9.289,0,0,1,265.935,323.324Z",
    transform: "translate(-19679.57 -589.796)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M249.025,326.855c.488.067,1.009.048,1.307.528a1.384,1.384,0,0,0-.15.084c-.319-.364-.757-.178-1.141-.249-1.494-.28-3.074-.064-4.5-.765a.464.464,0,0,0,.149-.228A31.3,31.3,0,0,0,249.025,326.855Z",
    transform: "translate(-19668.195 -593.187)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M244.211,317.444c.011-.046.021-.092.031-.139a6.834,6.834,0,0,1,3.766-.705,25.022,25.022,0,0,1-3.758.87A.436.436,0,0,1,244.211,317.444Z",
    transform: "translate(-19668.016 -587.932)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M243.573,321.923c-.181-.5-.37-1-.511-1.514a1.881,1.881,0,0,1,.4-1.991.629.629,0,0,0,.065.043,4.494,4.494,0,0,0,.258,3.1.583.583,0,0,1,.043.425c-.075-.021-.15-.038-.224-.062Z",
    transform: "translate(-19667.33 -588.949)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M244.345,326.087c.074.023.15.041.224.062a.464.464,0,0,1-.149.228c-.034-.1-.069-.195-.105-.292Z",
    transform: "translate(-19668.07 -593.111)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M244.165,318.208c-.011.047-.021.093-.032.139a.627.627,0,0,1-.065-.043C244.1,318.272,244.129,318.239,244.165,318.208Z",
    transform: "translate(-19667.934 -588.835)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M285.865,292.96c.024-.157.061-.315.092-.473A.964.964,0,0,1,285.865,292.96Z",
    transform: "translate(-19690.627 -574.872)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M287.886,264.851a10.744,10.744,0,0,0-1.842,4.056c-.788,2.608-2.07,5.048-2.544,7.5a.637.637,0,0,0-.223-.387,7.315,7.315,0,0,0,.45-2.7c.016-.789-.21-.975-1.005-1-.7-.026-.818.091-.9.925-.012.119-.022.239-.034.358a6.512,6.512,0,0,1-.448-2.182,1.275,1.275,0,0,0,1.813-.642c.723-1.689,1.271-3.45,1.957-5.157a.471.471,0,0,0-.113-.505,6.117,6.117,0,0,0,1.9-2.245h0c.986.23,1.726.99,2.7,1.251h0C288.767,263.756,288.326,264.335,287.886,264.851Z",
    transform: "translate(-19688.17 -558.793)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M290.747,265.984a7.614,7.614,0,0,0-1.448,2.494q-1.678,4.852-3.388,9.694c-.052.15,0,.395-.341.428v-1.219a.1.1,0,0,1,0-.01.637.637,0,0,1,.223.387c-.031.158-.068.316-.092.473a.963.963,0,0,0,.092-.473c.475-2.453,1.757-4.893,2.544-7.5a10.743,10.743,0,0,1,1.842-4.056c.441-.516.881-1.095,1.71-.732A1.17,1.17,0,0,0,290.747,265.984Z",
    transform: "translate(-19690.467 -560.144)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M289.3,265.113c-.012-.013-.02-.027-.034-.039a5.6,5.6,0,0,1,1.936-2.206A6.118,6.118,0,0,1,289.3,265.113Z",
    transform: "translate(-19692.473 -558.793)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M282.948,273.279c.538-1.859,1.323-3.627,1.978-5.444.024-.018.046-.038.07-.056a.471.471,0,0,1,.113.505c-.686,1.707-1.233,3.468-1.957,5.157a1.275,1.275,0,0,1-1.813.642,5.685,5.685,0,0,1,.936-.221A.7.7,0,0,0,282.948,273.279Z",
    transform: "translate(-19688.17 -561.459)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M289.221,267.693c.014.012.021.026.034.039-.024.018-.046.038-.07.056C289.2,267.757,289.21,267.725,289.221,267.693Z",
    transform: "translate(-19692.432 -561.413)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M232.941,434.074l0-.007c.821.257,1.641.511,2.459.773a.611.611,0,0,0,.581-.026,2.347,2.347,0,0,0,1.273.878c1.68.592,3.379,1.132,5.07,1.694a15.362,15.362,0,0,0,1.566.132l.219.071c-.151.152-.723-.21-.456.5.276.728-.2,1.2-.987,1.231a3.087,3.087,0,0,1-1.059-.224c-1.306-.414-2.6-.866-3.926-1.221a29.176,29.176,0,0,0-4.782-1.238A2.68,2.68,0,0,0,232.941,434.074Z",
    transform: "translate(-19661.875 -651.729)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M232.625,433.953l0,.007a2.68,2.68,0,0,1-.047,2.559,8.483,8.483,0,0,0-.262-2.662Z",
    transform: "translate(-19661.559 -651.615)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M239.786,435.308a2.5,2.5,0,0,0,1.3.812c2.156.677,4.306,1.378,6.459,2.071a15.346,15.346,0,0,1-1.566-.132c-1.691-.562-3.389-1.1-5.07-1.694a2.348,2.348,0,0,1-1.273-.878A.583.583,0,0,0,239.786,435.308Z",
    transform: "translate(-19665.533 -652.403)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M281.433,285.08c.178-.4.416-.718.912-.548.552.189.492.663.453,1.107a5.047,5.047,0,0,0-.128,2.109c-.011-.01-.019-.02-.032-.03-.612.22-.52.774-.509,1.223.067,2.974-1.036,5.773-1.287,8.7-.028.328-.145.65-.6.564a56.018,56.018,0,0,1,.791-8.534,18.275,18.275,0,0,0,.157-4.336A.539.539,0,0,0,281.433,285.08Z",
    transform: "translate(-19687.57 -570.528)",
    fill: "#485387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M280.845,301.479c.251-2.926,1.354-5.724,1.287-8.7-.011-.449-.1-1,.509-1.223.013.01.021.02.032.03a.132.132,0,0,0,0,.018c-.373.37-.193.843-.229,1.272a19.72,19.72,0,0,1-.172,2.653c-.327,1.491-.643,2.987-.87,4.5a6.939,6.939,0,0,1-.341,2.138c-.115.237-.082.627-.493.564s-.245-.447-.331-.692C280.7,302.129,280.817,301.807,280.845,301.479Z",
    transform: "translate(-19687.574 -574.367)",
    fill: "#485387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M283.253,283.531c.8.029,1.021.215,1.005,1a7.316,7.316,0,0,1-.45,2.7l-.008-.008a5.048,5.048,0,0,1,.128-2.109c.039-.444.1-.918-.453-1.107-.5-.17-.734.151-.913.548a.539.539,0,0,1-.244.254c.012-.119.022-.239.034-.358C282.435,283.623,282.549,283.506,283.253,283.531Z",
    transform: "translate(-19688.703 -570.009)",
    fill: "#485387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M285.568,291.63a.09.09,0,0,0,0,.01.127.127,0,0,1,0-.018Z",
    transform: "translate(-19690.461 -574.403)",
    fill: "#485387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M175.034,388.8c-.691,3.642-1.225,7.315-1.822,10.974-.014,0-.028,0-.043,0-.193-.021-.353-.147-.544-.175.626-3.5,1.267-7,1.872-10.5.474-2.747,1.087-5.467,1.372-8.248a35.3,35.3,0,0,1,.912-5.979l.312.206C176.339,379.641,175.9,384.25,175.034,388.8Z",
    transform: "translate(-19629.154 -619.595)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    d: "M173.211,429.139c-.018.115-.036.23-.054.344-.411.068-.5-.191-.533-.516.191.027.351.153.544.175C173.184,429.143,173.2,429.139,173.211,429.139Z",
    transform: "translate(-19629.154 -648.961)",
    fill: "#686767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    "data-name": "Path 6654",
    d: "M177.942,368.9c1.168.581,2.338,1.157,3.5,1.746.953.483,1.053.844.567,1.926a7.165,7.165,0,0,1-2.445-.685v-.021c-.107-.185-.194-.414-.48-.235-.717-.52-1.665-.688-2.215-1.461C177.309,369.813,177.485,369.238,177.942,368.9Z",
    transform: "translate(-19631.459 -616.351)",
    fill: "#f2a35b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M177.9,368.853l.04.02c-.457.34-.633.916-1.072,1.271h0C177.1,368.937,177.1,368.937,177.9,368.853Z",
    transform: "translate(-19631.459 -616.328)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M182.2,375.029v.021c-.055-.016-.111-.036-.168-.05l-.312-.206C182,374.615,182.089,374.844,182.2,375.029Z",
    transform: "translate(-19634.09 -619.518)",
    fill: "#fbd247"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M173.166,436.43c-.494.92-.548.933-1.017.243C172.464,436.49,172.758,436.226,173.166,436.43Z",
    transform: "translate(-19628.896 -652.972)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M172.57,435.611c.292.025.677-.134.6.413-.408-.2-.7.06-1.017.243C172.256,436.028,171.989,435.562,172.57,435.611Z",
    transform: "translate(-19628.896 -652.565)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M222.273,337.635a32.274,32.274,0,0,1,3.929,1.121.842.842,0,0,0-.133.065c-3.007,2.175-6.091,4.239-8.888,6.705a5.9,5.9,0,0,0-2.221,5.669c0,.016.007.032.01.048-2.783,0-5.566-.013-8.345.176-.929.064-1.1.184-1.145,1.144a4,4,0,0,0,.121,1.557h0c-.155,1.279-.309,2.558-.467,3.859.168.3.481.2.748.213,1.782.059,3.565.107,5.348.161.821.024.847.026.8-.87-.062-1.131-.17-2.259-.259-3.389l.338-.112h0c.142,1.224.316,2.445.409,3.674.04.533.156.8.752.8s.773-.26.748-.8a3.517,3.517,0,0,1,.067-.593h0l.211.232h0c.069.441-.086,1.018.49,1.151a2.587,2.587,0,0,0-.064.293c0,.011,0,.02,0,.03-.246.014-.431.115-.419.5.007.244.012.489.018.734-.07.144-.14.286-.2.431-.032.084-.061.168-.09.252q-.017-.521-.032-1.041c-.026-.874-.025-.879-.877-.854a2.443,2.443,0,0,0-.465.1c.147,1.435.29,2.833.432,4.229-.032.061-.061.123-.1.184a1.175,1.175,0,0,1-.171.6,33.553,33.553,0,0,1-.533-3.958c-.1-1.153-.1-1.133-1.295-1.163-1.735-.044-3.471-.1-5.2-.192-.552-.03-.822.061-.808.691a39.71,39.71,0,0,0,.187,4.348,16.387,16.387,0,0,1-.171,4.338c-.027.2-.061.423-.26.517-.706.331-.467.924-.429,1.465h0a2.1,2.1,0,0,1-.629.245c0-.072,0-.145.005-.218.063-6.827.089-13.654-.016-20.479a43.742,43.742,0,0,1,0-6.64c0-.011,0-.024,0-.035a3.146,3.146,0,0,0,2.042.36h0a4.591,4.591,0,0,0,.976,2.693c.555.8,1.146,1.57,1.759,2.324.548.673.893.631,1.162-.192.511-1.569,1.187-3.112,1.006-4.829a2.634,2.634,0,0,1,.037-.484,3.377,3.377,0,0,0,1.8-.618c1.089-.605,2.117-1.323,3.2-1.947a1.116,1.116,0,0,0,.565-1.307c-.188-1.262-.412-2.52-.487-3.8a20.44,20.44,0,0,0,4.358.179h.054C220.24,337.018,220.351,337.036,222.273,337.635Z",
    transform: "translate(-19645.928 -597.969)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M228.015,386.58c0-.01,0-.019,0-.03a2.565,2.565,0,0,1,.064-.293,1.123,1.123,0,0,0,.228.031c0,.1-.009.2-.013.3A2,2,0,0,0,228.015,386.58Z",
    transform: "translate(-19659.225 -625.775)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M228.45,355.613a5.9,5.9,0,0,1,2.221-5.67c2.8-2.466,5.881-4.53,8.888-6.7a.844.844,0,0,1,.133-.065c.077.035.156.066.232.1h0c-1.723,1.249-3.452,2.491-5.169,3.749a34.569,34.569,0,0,0-5.1,4.416,3.264,3.264,0,0,0-.942,2.405c.023.6-.016,1.208-.027,1.812h-.229C228.457,355.645,228.452,355.63,228.45,355.613Z",
    transform: "translate(-19659.414 -602.388)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6662",
    "data-name": "Path 6662",
    d: "M226.585,390.092c.064-.145.134-.288.2-.431,0,.14.006.281.01.422-.073.271.007.6-.288.789-.006-.176-.011-.352-.016-.528C226.523,390.26,226.552,390.176,226.585,390.092Z",
    transform: "translate(-19658.398 -627.623)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M224.023,396.669c.034-.061.063-.123.1-.184.008.082.017.165.026.246.064.3.137.609-.249.767-.016-.075-.028-.152-.043-.228A1.175,1.175,0,0,0,224.023,396.669Z",
    transform: "translate(-19656.965 -631.328)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M203.2,351.983a43.757,43.757,0,0,0,0,6.64c.105,6.825.079,13.652.016,20.479,0,.072,0,.145,0,.218a1.12,1.12,0,0,1-.295.02h0q-.04-6.368-.08-12.737c-.016-2.79.036-5.582-.057-8.37a34.528,34.528,0,0,1,.084-6.4c.113.036.226.076.338.12C203.2,351.96,203.2,351.972,203.2,351.983Z",
    transform: "translate(-19645.463 -607.086)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    d: "M234.541,334.89a20.444,20.444,0,0,1-4.358-.179c-.005-.091-.016-.181-.02-.273l4.412.122c.007.117.013.226.02.331Z",
    transform: "translate(-19660.393 -597.645)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M251.223,328.377a1.58,1.58,0,0,0,.828-.352c.029.151.059.3.079.457.276,2.244.38,2.347,2.618,2.662,1.643.231,1.728.327,1.459,2.009a15.08,15.08,0,0,0-.135,2.295c-.014,1.845-.183,1.98-1.977,1.384-1.534-.509-3.085-.96-4.628-1.441a10.154,10.154,0,0,0-2.84-.569,1.5,1.5,0,0,0-.276.057c-.238-.455-.744-.506-1.181-.633-1.011-.295-2.035-.557-3.059-.795s-1.688-.724-1.73-1.85a.631.631,0,0,0-.038-.184c1.772.059,3.544.1,5.315.059,2.126-.056,2.811-.908,2.452-3A9.014,9.014,0,0,0,251.223,328.377Z",
    transform: "translate(-19665.914 -594.164)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M253.485,334.484a1.5,1.5,0,0,1,.276-.057,10.155,10.155,0,0,1,2.84.569c1.542.481,3.094.932,4.628,1.441,1.794.6,1.963.46,1.977-1.384a15.076,15.076,0,0,1,.135-2.295c.269-1.681.184-1.778-1.459-2.009-2.238-.315-2.341-.419-2.618-2.662-.02-.153-.05-.305-.079-.457a.945.945,0,0,0,.228-.332h0a5.132,5.132,0,0,1,.244,1.909c.051.611.338.987.979,1.008.726.025,1.426.245,2.162.24,1.014-.006,1.045.034.986,1.014-.1,1.61-.33,3.212-.287,4.831a1.806,1.806,0,0,1-.046.359c-.084.464-.272.747-.821.553-.532-.187-1.08-.33-1.62-.5a52.424,52.424,0,0,0-7.452-2.057h0A1.043,1.043,0,0,0,253.485,334.484Z",
    transform: "translate(-19673.051 -593.769)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6668",
    "data-name": "Path 6668",
    d: "M245.371,331.972c-1.771.046-3.543,0-5.315-.058a.755.755,0,0,0-.241-.338.7.7,0,0,1,.568-.123,38.823,38.823,0,0,0,5.537.145c1.237,0,1.643-.469,1.679-1.691.008-.322.011-.643.016-.966.069.014.138.016.208.028C248.182,331.064,247.5,331.917,245.371,331.972Z",
    transform: "translate(-19665.629 -594.661)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6669",
    "data-name": "Path 6669",
    d: "M260.376,328.119a9.012,9.012,0,0,1-3.114.1c0-.009,0-.017,0-.026a.817.817,0,0,0-.054-.086,3.034,3.034,0,0,1,1.463-.16,6.383,6.383,0,0,0,2.5-.393c.014.072.026.145.041.217A1.579,1.579,0,0,1,260.376,328.119Z",
    transform: "translate(-19675.064 -593.906)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6670",
    "data-name": "Path 6670",
    d: "M265.906,327.63c-.015-.072-.027-.145-.041-.217.09-.036.181-.073.269-.115A.945.945,0,0,1,265.906,327.63Z",
    transform: "translate(-19679.771 -593.769)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6671",
    "data-name": "Path 6671",
    d: "M257.079,328.844c0,.009,0,.017,0,.026-.069-.012-.138-.014-.208-.028a1.381,1.381,0,0,1,.149-.084A.838.838,0,0,1,257.079,328.844Z",
    transform: "translate(-19674.891 -594.562)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M241.848,337.471c1.024.237,2.048.5,3.059.795.437.127.943.178,1.181.633a.917.917,0,0,0-.159.072A32.268,32.268,0,0,0,242,337.849c-1.922-.6-2.032-.617-2.142-2.419l.221.006a.632.632,0,0,1,.038.184C240.16,336.747,240.813,337.231,241.848,337.471Z",
    transform: "translate(-19665.654 -598.184)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    d: "M253.138,343.089a.921.921,0,0,1,.159-.072,1.041,1.041,0,0,1,.074.176h0C253.294,343.155,253.215,343.124,253.138,343.089Z",
    transform: "translate(-19672.861 -602.302)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6674",
    "data-name": "Path 6674",
    d: "M240.056,335.043l-.221-.006c-.006-.106-.012-.214-.02-.331A.755.755,0,0,1,240.056,335.043Z",
    transform: "translate(-19665.629 -597.79)",
    fill: "#d7cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    d: "M245,398.321c.956.447,1.394,1.419,2.072,2.136a19.137,19.137,0,0,1,2.168,2.7c.055.038.1.084.156.125a47.7,47.7,0,0,1-1.108,5.574,5.19,5.19,0,0,0-.164.945,1.089,1.089,0,0,0-.169,0c-1.5.856-3.052.211-4.582.127-.264-.015-.516-.152-.789-.195a65.158,65.158,0,0,0,1.984-8.146C244.746,400.505,244.745,399.4,245,398.321Z",
    transform: "translate(-19667.133 -632.324)",
    fill: "#626263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M252.11,402.926a19.134,19.134,0,0,0-2.168-2.7c-.678-.717-1.115-1.689-2.072-2.136.006-.026.009-.053.016-.079h0c.46-.318.691.079.875.347.416.606,1,1.069,1.408,1.659.681.99,1.76,1.692,2.11,2.918,0,.041-.01.081-.013.121C252.214,403.01,252.164,402.964,252.11,402.926Z",
    transform: "translate(-19670.004 -632.09)",
    fill: "#626263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M243.31,423.481c1.53.084,3.079.729,4.582-.127a1.081,1.081,0,0,1,.169,0c0,.042-.006.083,0,.127a2.064,2.064,0,0,1-2.479.526,2.254,2.254,0,0,0-.946-.04,3.421,3.421,0,0,1-2.165-.5c.019-.062.036-.124.054-.187C242.794,423.329,243.046,423.466,243.31,423.481Z",
    transform: "translate(-19667.068 -645.877)",
    fill: "#626263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M232.625,433.93l-.3-.1c.083-.014.164-.014.245-.02C232.585,433.852,232.606,433.89,232.625,433.93Z",
    transform: "translate(-19661.559 -651.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M247.812,398.227c-.016-.007-.032-.018-.049-.025.021-.017.041-.038.064-.054h0C247.821,398.173,247.818,398.2,247.812,398.227Z",
    transform: "translate(-19669.943 -632.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M217.48,420.151a37.81,37.81,0,0,0,2.881-4.9,1.318,1.318,0,0,0,.157-.541,14.479,14.479,0,0,0,4.516,1.818l.027,0c-1.1,1.846-2.278,3.672-1.53,5.963-.387-.176-.673.053-.887.424-.474.821-1.157.747-1.905.506a4.337,4.337,0,0,1-2.036-1.667,2.809,2.809,0,0,0-1.562-1.229A1.475,1.475,0,0,0,217.48,420.151Z",
    transform: "translate(-19653.32 -641.223)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M228.969,416.216a14.477,14.477,0,0,1-4.516-1.818.575.575,0,0,0-.062-.266h0c.831.08,1.4.728,2.144,1,.848.3,1.682.654,2.521.985h0l-.059.1Z",
    transform: "translate(-19657.256 -640.908)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6682",
    "data-name": "Path 6682",
    d: "M218.22,428.656a4.337,4.337,0,0,0,2.036,1.667c.749.241,1.432.315,1.905-.506.214-.371.5-.6.887-.424.025.076.046.151.075.229-.366-.2-.547-.083-.727.3-.445.939-.812,1.07-1.806.845a4.253,4.253,0,0,1-2.568-1.858c-.442-.628-.878-1.267-1.77-1.272a1.251,1.251,0,0,0,.406-.209A2.809,2.809,0,0,1,218.22,428.656Z",
    transform: "translate(-19652.838 -648.125)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    d: "M220.224,414.618a1.318,1.318,0,0,1-.157.541,37.81,37.81,0,0,1-2.88,4.9,1.476,1.476,0,0,1-.339.375,2.007,2.007,0,0,0-.247-.03,52.214,52.214,0,0,0,3.464-5.862l.007,0Z",
    transform: "translate(-19653.025 -641.128)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6684",
    "data-name": "Path 6684",
    d: "M224.338,414.4l-.153-.076-.007,0c.032-.062.066-.123.1-.185h0A.575.575,0,0,1,224.338,414.4Z",
    transform: "translate(-19657.141 -640.908)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    d: "M216.658,427.391a1.253,1.253,0,0,1-.406.209c.055-.079.1-.16.159-.239A2.025,2.025,0,0,1,216.658,427.391Z",
    transform: "translate(-19652.838 -648.089)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    "data-name": "Path 6686",
    d: "M232.368,418.684h.022c-.315.821-.612,1.651-.955,2.46a6.791,6.791,0,0,0-.545,3.529c-.018-.009-.035-.018-.052-.026C230.09,422.356,231.264,420.529,232.368,418.684Z",
    transform: "translate(-19660.627 -643.378)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M234.465,418.569l.059-.1-.037.1Z",
    transform: "translate(-19662.725 -643.263)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M217.071,373.344a7.684,7.684,0,0,0-2.118.051.988.988,0,0,0-.162-.121.483.483,0,0,0-.322.221,3.3,3.3,0,0,0-1.36-.043,27.807,27.807,0,0,1-4.475.1c0-.019,0-.037,0-.055a4.664,4.664,0,0,0,.019-.845c-.07-.962.358-1.321,1.327-1.419,2.129-.212,4.258-.217,6.391-.224a2.618,2.618,0,0,0,1.41-.2,9.622,9.622,0,0,0,1.108,2.349l-1.584.178A1.313,1.313,0,0,0,217.071,373.344Z",
    transform: "translate(-19648.703 -617.39)",
    fill: "#f2a35b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M228.641,370.636a1.251,1.251,0,0,0,.2-.147h0a11.737,11.737,0,0,0,1.219,2.462l-.309.034A9.62,9.62,0,0,1,228.641,370.636Z",
    transform: "translate(-19659.564 -617.216)",
    fill: "#fcd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M221.72,376.2a.994.994,0,0,1,.162.121l-.067.008h0l-.338.112c-.026-.01-.052-.012-.079-.021A.483.483,0,0,1,221.72,376.2Z",
    transform: "translate(-19655.631 -620.316)",
    fill: "#fcd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    d: "M215.9,370.839c-2.133.007-4.262.011-6.391.224-.969.1-1.4.457-1.327,1.419a4.667,4.667,0,0,1-.019.845c0,.019,0,.036,0,.055-.085-.006-.17-.006-.255-.014h0a4,4,0,0,1-.121-1.557c.047-.96.215-1.081,1.145-1.144,2.779-.189,5.562-.172,8.345-.176.01.05.021.1.033.147A2.618,2.618,0,0,1,215.9,370.839Z",
    transform: "translate(-19648.23 -617.216)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M228.57,370.489h.229a1.249,1.249,0,0,1-.2.147C228.591,370.587,228.58,370.539,228.57,370.489Z",
    transform: "translate(-19659.521 -617.216)",
    fill: "#fcd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    d: "M258.135,374.9c-.478-.794-.288-.977,1.023-1.166,0,.737.591,1.056,1.194,1.314a19.744,19.744,0,0,0,3.774,1.116c-.593,1.615-1.528,3.082-2.065,4.72A44.661,44.661,0,0,1,258.135,374.9Z",
    transform: "translate(-19675.443 -618.977)",
    fill: "#494d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M257.635,374.577a44.668,44.668,0,0,0,3.926,5.985c-.013.041-.03.08-.042.121h0c-.447.014-.6-.317-.8-.632-1.054-1.677-2.135-3.337-3.182-5.017-.935-1.5-.771-1.786,1.019-1.892a1.191,1.191,0,0,1,.121,0,1.531,1.531,0,0,0-.019.267C257.347,373.6,257.157,373.784,257.635,374.577Z",
    transform: "translate(-19674.943 -618.655)",
    fill: "#494d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M261.85,375.023c-.6-.258-1.192-.577-1.194-1.314l.04-.006c.03,0,.059-.011.089-.014a2.813,2.813,0,0,0,1.891,1.353c1.009.3,2.028.564,3.043.844-.029.086-.064.169-.1.254A19.745,19.745,0,0,1,261.85,375.023Z",
    transform: "translate(-19676.941 -618.952)",
    fill: "#494d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M260.656,373.416a1.536,1.536,0,0,1,.019-.267,2.248,2.248,0,0,0,.111.246c-.03,0-.059.011-.089.014Z",
    transform: "translate(-19676.941 -618.66)",
    fill: "#494d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M257.3,425.714c0-.006,0-.011,0-.016l.005.016Z",
    transform: "translate(-19675.121 -647.186)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M265.571,406.209a26.375,26.375,0,0,0-.722,5.072c-.008.072-.008.146-.011.218a3.1,3.1,0,0,0-.914-1.122,8.3,8.3,0,0,1-1.206-1.188c-.19-.233-.3-.249-.39-.187.054-.261.2-.548,0-.739A10.69,10.69,0,0,0,265.571,406.209Z",
    transform: "translate(-19677.846 -636.606)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    d: "M261.954,407.924a.677.677,0,0,0-.312-.149,20.506,20.506,0,0,0,3.646-2.191c-.032.095-.058.19-.087.285A10.691,10.691,0,0,1,261.954,407.924Z",
    transform: "translate(-19677.479 -636.268)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M261.912,410.7c.2.191.058.478,0,.739-.112.08-.178.294-.291.376-.2-.332.189-.676.125-1.01.032-.024.063-.051.1-.073Z",
    transform: "translate(-19677.436 -639.045)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    d: "M267.823,411.374c0-.072,0-.145.011-.218a26.37,26.37,0,0,1,.722-5.072c.03-.033.058-.07.088-.1.061,2.215-.611,4.375-.517,6.6,0,.1-.121.2-.185.3A2.322,2.322,0,0,0,267.823,411.374Z",
    transform: "translate(-19680.832 -636.483)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M261.954,410.526l-.065.032c-.034.022-.065.049-.1.073a.431.431,0,0,0-.15-.254A.678.678,0,0,1,261.954,410.526Z",
    transform: "translate(-19677.479 -638.869)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M269.514,405.585c0,.061,0,.121,0,.181-.03.034-.058.071-.088.1C269.456,405.775,269.481,405.68,269.514,405.585Z",
    transform: "translate(-19681.703 -636.268)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6704",
    "data-name": "Path 6704",
    d: "M202.135,310.232c1.256.548,2.507,1.11,3.77,1.649-2.566.016-5.144-.289-7.683.337-.051.024-.1.038-.156.059-.038-.1-.079-.2-.147-.225-1.07-.4-1.792-1.4-2.935-1.665a.883.883,0,0,1-.429-.217c-1.493-1.569-3.361-1.039-5.152-.946-.009-.672-.572-.987-1.023-1.347-1.442-1.152-2.818-2.381-4.3-3.585,2.449-.295,4.806-1.335,7.277-.361.3.119.629.267.91.057a5.4,5.4,0,0,0,1.383.923v0h0a20.837,20.837,0,0,0,3.734,2,13.535,13.535,0,0,0,3.059,1.6.731.731,0,0,0,.134.116.647.647,0,0,0,.126,0C200.783,309.508,201.315,309.875,202.135,310.232Z",
    transform: "translate(-19635.375 -580.864)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M190.54,303.526c-2.472-.974-4.828.066-7.277.361,1.479,1.2,2.855,2.433,4.3,3.585.451.36,1.014.675,1.023,1.347l-.052,0h0a48.555,48.555,0,0,0-5.4-4.448c-.239-.178-.641-.234-.544-.668a6.9,6.9,0,0,1,2.7-.56c2.053-.339,4.149-.774,6.119.394h0c.014.017.031.028.044.044C191.169,303.793,190.843,303.646,190.54,303.526Z",
    transform: "translate(-19634.555 -580.458)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M220.011,314.551a.731.731,0,0,1-.134-.116c.055.017.108.037.165.053h0l.089.007c0,.02.005.037.007.057A.635.635,0,0,1,220.011,314.551Z",
    transform: "translate(-19654.805 -586.787)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6707",
    "data-name": "Path 6707",
    d: "M214.826,322.07c2.539-.626,5.117-.321,7.683-.337.275.117.548.24.824.354a58.735,58.735,0,0,0-8.587.223,1.892,1.892,0,0,1-.075-.181C214.722,322.108,214.775,322.094,214.826,322.07Z",
    transform: "translate(-19651.977 -590.716)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6708",
    "data-name": "Path 6708",
    d: "M233.621,322.58Z",
    transform: "translate(-19662.268 -591.208)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6709",
    "data-name": "Path 6709",
    d: "M193.76,316.17c2.005-.079,3.427,1.194,5.03,2.036.558.292,1.072.668,1.646.94a4.329,4.329,0,0,1-2.16.229,58.759,58.759,0,0,0-7.616-.215c-2.107-.027-2.207-.025-1.529-1.754a2.969,2.969,0,0,0,2.807-1.21,1.306,1.306,0,0,0,0-.14A3.16,3.16,0,0,0,193.76,316.17Z",
    transform: "translate(-19637.912 -587.667)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6710",
    "data-name": "Path 6710",
    d: "M192.383,316.165a2.969,2.969,0,0,1-2.807,1.21c.031-.08.062-.159.1-.246h0a2.705,2.705,0,0,0,2.258-.87,1.845,1.845,0,0,1,.4-.259h0c.016.011.035.016.052.027A1.306,1.306,0,0,1,192.383,316.165Z",
    transform: "translate(-19638.357 -587.636)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    d: "M188.446,318.969c-.678,1.729-.579,1.727,1.529,1.754a58.759,58.759,0,0,1,7.616.215,4.328,4.328,0,0,0,2.16-.229c.081.039.159.081.243.115-.248.5-.71.453-1.157.467-1.015.03-2.021-.129-3.029-.159-2.35-.068-4.7-.048-7.056-.043-1.228,0-1.555-.531-.99-1.631a1.5,1.5,0,0,1,.459-.522c.068.011.135.018.2.033Z",
    transform: "translate(-19637.227 -589.229)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6712",
    "data-name": "Path 6712",
    d: "M189.309,318.716h-.02c-.07-.015-.137-.022-.2-.033a3.282,3.282,0,0,1,.32-.213h0C189.371,318.557,189.34,318.636,189.309,318.716Z",
    transform: "translate(-19638.09 -588.977)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6713",
    "data-name": "Path 6713",
    d: "M200.873,316.748a.882.882,0,0,0,.429.217c1.143.263,1.865,1.269,2.935,1.665.068.024.108.122.147.225-.055.024-.112.044-.168.065-.573-.272-1.088-.648-1.646-.94-1.6-.842-3.025-2.115-5.03-2.036a3.159,3.159,0,0,1-1.819-.113c0-.01,0-.02,0-.029C197.512,315.709,199.379,315.179,200.873,316.748Z",
    transform: "translate(-19641.691 -587.442)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6714",
    "data-name": "Path 6714",
    d: "M195.66,316.022c-.017-.01-.035-.016-.052-.027l.052,0C195.66,316,195.66,316.012,195.66,316.022Z",
    transform: "translate(-19641.633 -587.632)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    d: "M214.546,322.852c-.084-.034-.162-.076-.243-.115.056-.021.113-.041.168-.065A1.894,1.894,0,0,0,214.546,322.852Z",
    transform: "translate(-19651.779 -591.258)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6716",
    "data-name": "Path 6716",
    d: "M205.637,290.647h0c-.345-.938-.688-1.875-1.049-2.859-1,.467-1.351,1.426-1.974,2.128h0c-.263.328-.489.561-.919.137-.269-.264-.4-.644-.666-.906,0-.063,0-.125.007-.189a28.392,28.392,0,0,1-.516-4.124c1.33,1.609,2.83,2.919,5.183,2.61a2.837,2.837,0,0,0,2.224-1.19,4.856,4.856,0,0,0,.085.987c.013.2.037.4.053.6-.416,1-1.092,1.867-1.551,2.846C206.233,291.282,205.915,291,205.637,290.647Z",
    transform: "translate(-19644.297 -570.717)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6717",
    "data-name": "Path 6717",
    d: "M200.665,288.544c-.006.064,0,.126-.007.189a.958.958,0,0,0-.32-.217,15.284,15.284,0,0,1-.472-4.445h0q.14.176.282.347A28.387,28.387,0,0,0,200.665,288.544Z",
    transform: "translate(-19643.928 -570.304)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6718",
    "data-name": "Path 6718",
    d: "M216.806,287.773a4.859,4.859,0,0,1-.085-.987,2.586,2.586,0,0,0,.331-.972q.019.951.038,1.9a5.3,5.3,0,0,1-.23.657C216.843,288.173,216.819,287.974,216.806,287.773Z",
    transform: "translate(-19653.092 -571.25)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6719",
    "data-name": "Path 6719",
    d: "M205.635,287.2c-2.353.309-3.853-1-5.183-2.61,0-.031,0-.062-.005-.092s-.036-.073-.052-.111a17.216,17.216,0,0,1,1.734,1.456c2,1.645,4.2,1.474,5.74-.383-.006.184-.01.368-.01.551A2.837,2.837,0,0,1,205.635,287.2Z",
    transform: "translate(-19644.23 -570.476)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6720",
    "data-name": "Path 6720",
    d: "M200.186,284.42q-.141-.172-.282-.347c.08.042.149.1.225.144.016.038.037.072.052.111S200.185,284.39,200.186,284.42Z",
    transform: "translate(-19643.963 -570.305)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    "data-name": "Path 6721",
    d: "M216.731,286.235c.109-.131.217-.271.32-.421a2.586,2.586,0,0,1-.331.972C216.721,286.6,216.725,286.419,216.731,286.235Z",
    transform: "translate(-19653.092 -571.25)",
    fill: "#d1d8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6722",
    "data-name": "Path 6722",
    d: "M203.243,295.835a.412.412,0,0,0,.087.226,2.317,2.317,0,0,1,.322,2.557c-.15.486-.281.977-.416,1.467a4.444,4.444,0,0,0-1.417-.691.78.78,0,0,0,.136-.156c.161-1.4-.332-2.744-.353-4.127a1.264,1.264,0,0,0,.246.44C202.3,296.027,202.743,296.312,203.243,295.835Z",
    transform: "translate(-19644.885 -576.296)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    "data-name": "Path 6723",
    d: "M201.556,298.523a.783.783,0,0,1-.136.156c-.027,0-.054-.012-.083-.016h0a3.91,3.91,0,0,0-.092-1.067,15.07,15.07,0,0,1-.347-3.8,1.722,1.722,0,0,1,.305.6C201.224,295.778,201.717,297.127,201.556,298.523Z",
    transform: "translate(-19644.484 -575.582)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6724",
    "data-name": "Path 6724",
    d: "M203.376,305.429v0a5.4,5.4,0,0,1-1.383-.923.431.431,0,0,0,.038-.028,4.445,4.445,0,0,1,1.417.691C203.423,305.258,203.4,305.344,203.376,305.429Z",
    transform: "translate(-19645.096 -581.383)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6725",
    "data-name": "Path 6725",
    d: "M201.939,304.489c-.014-.016-.031-.027-.044-.044.029,0,.055.011.083.016A.424.424,0,0,1,201.939,304.489Z",
    transform: "translate(-19645.045 -581.364)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6726",
    "data-name": "Path 6726",
    d: "M203.2,295.037h0c.021.106.025.229.042.339-.5.478-.945.192-1.395-.285a1.262,1.262,0,0,1-.246-.44c0-.128.008-.256.014-.385.264.262.4.642.666.906C202.712,295.6,202.938,295.365,203.2,295.037Z",
    transform: "translate(-19644.885 -575.839)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    d: "M201.254,294.011c-.006.128-.016.257-.014.385a1.722,1.722,0,0,0-.305-.6A.958.958,0,0,1,201.254,294.011Z",
    transform: "translate(-19644.521 -575.582)",
    fill: "#a9b3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6728",
    "data-name": "Path 6728",
    d: "M184.156,348.136c.095,1.094-.035,2.188-.023,3.282.074,6.729.246,13.457.312,20.187q.047,4.672.186,9.356a3.94,3.94,0,0,1-.056,1.152,17.207,17.207,0,0,1-1-4.337,1.542,1.542,0,0,1,.168-.82,1.155,1.155,0,0,0-.114-1.158,5.834,5.834,0,0,1-1.051-2.671c-.455-1.632-.841-3.284-1.322-5.19-1.367,2.726-1.83,5.5-2.686,8.132s-1.574,5.321-2.352,7.985c-.258.021-.417.243-.606.4,1.59-5.534,3.115-11.089,4.937-16.555a3.141,3.141,0,0,0,.311-1.766,9.134,9.134,0,0,1,.434-5.238c.028-.006.055-.009.084-.016.669-.606.732-1.4.053-1.864a9.229,9.229,0,0,0-4.172-1.912,2.254,2.254,0,0,1-.01-1.952,6,6,0,0,0,.455-1.38,4.64,4.64,0,0,1,2.683-3.631c1.213-.583,1.481-1.88,2.063-2.94l1.721.876C184.163,348.1,184.162,348.117,184.156,348.136Z",
    transform: "translate(-19630.771 -604.575)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    d: "M194.751,382q-.134-4.677-.186-9.356c-.066-6.73-.238-13.457-.312-20.187-.012-1.094.118-2.187.023-3.282.005-.018.006-.037.011-.055l.078.04c.278.229.618.442.415.883a3.541,3.541,0,0,0-.146,1.554c-.007,3.03.008,6.058.174,9.088a65.385,65.385,0,0,1-.021,6.792c-.168,3.4.477,6.769.239,10.163a1.336,1.336,0,0,0,.043.234,42.025,42.025,0,0,1,.013,5.207.462.462,0,0,1-.22.4c-.063-.11-.114-.223-.168-.334A3.94,3.94,0,0,0,194.751,382Z",
    transform: "translate(-19640.895 -605.616)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6730",
    "data-name": "Path 6730",
    d: "M176.08,427.809c0,.013-.007.025-.011.037-.283.212-.161.8-.709.765l.114-.4C175.663,428.052,175.822,427.83,176.08,427.809Z",
    transform: "translate(-19630.639 -648.332)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6731",
    "data-name": "Path 6731",
    d: "M181.515,350.053a4.64,4.64,0,0,0-2.683,3.631,6,6,0,0,1-.455,1.38,2.254,2.254,0,0,0,.011,1.952c-.013,0-.026-.005-.039-.006-.525-.289-.852-.576-.524-1.3a12.542,12.542,0,0,0,.95-2.869,3.448,3.448,0,0,1,2.018-2.668,3.452,3.452,0,0,0,2.064-2.389,1.042,1.042,0,0,1,.572-.75l.15.077C183,348.172,182.727,349.47,181.515,350.053Z",
    transform: "translate(-19631.906 -604.484)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6732",
    "data-name": "Path 6732",
    d: "M179.213,368.866a9.23,9.23,0,0,1,4.172,1.912c.679.465.616,1.258-.053,1.864-.029.008-.056.01-.084.016.011-.035.021-.07.034-.106.486-1.082.386-1.444-.567-1.926-1.163-.589-2.334-1.164-3.5-1.746l0,0Z",
    transform: "translate(-19632.73 -616.335)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6733",
    "data-name": "Path 6733",
    d: "M179.171,368.87l0,0-.04-.02c.014,0,.026.005.039.006Z",
    transform: "translate(-19632.684 -616.328)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6734",
    "data-name": "Path 6734",
    d: "M176.949,427.8c-.014.013-.024.027-.038.041,0-.013.008-.025.011-.037A.273.273,0,0,1,176.949,427.8Z",
    transform: "translate(-19631.48 -648.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6735",
    "data-name": "Path 6735",
    d: "M205.734,342.938a5.816,5.816,0,0,0-2.042-.41,45.689,45.689,0,0,0-.09-5.862c-.118-1,.068-1.567,1.155-1.613a.706.706,0,0,0,.5-.284h.032l.075.069C205.473,337.538,205.841,340.227,205.734,342.938Z",
    transform: "translate(-19645.953 -597.824)",
    fill: "#d1d9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6736",
    "data-name": "Path 6736",
    d: "M204.206,335.044c-1.087.046-1.273.615-1.155,1.613a45.682,45.682,0,0,1,.09,5.862,2.726,2.726,0,0,0-.34.039c-.006-1.369-.036-2.737-.009-4.106a23.873,23.873,0,0,0-.214-2.754c-.08-.842.024-.911.831-.939.431-.015.864,0,1.3,0A.706.706,0,0,1,204.206,335.044Z",
    transform: "translate(-19645.4 -597.816)",
    fill: "#d1d9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6737",
    "data-name": "Path 6737",
    d: "M207.326,334.74l.07-.023c0,.031,0,.062.005.093Z",
    transform: "translate(-19647.994 -597.797)",
    fill: "#d1d9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6738",
    "data-name": "Path 6738",
    d: "M205.873,352.257h0a3.146,3.146,0,0,1-2.042-.36c0-.053,0-.106,0-.159a5.815,5.815,0,0,1,2.042.41c0,.036,0,.072,0,.108Z",
    transform: "translate(-19646.096 -607.034)",
    fill: "#d1d9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6739",
    "data-name": "Path 6739",
    d: "M203.43,351.9c-.112-.043-.224-.084-.338-.12a2.75,2.75,0,0,1,.34-.039C203.431,351.8,203.43,351.849,203.43,351.9Z",
    transform: "translate(-19645.695 -607.039)",
    fill: "#d1d9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6740",
    "data-name": "Path 6740",
    d: "M204.256,411.7c.4,1.075.027,2.245.349,3.307a10.514,10.514,0,0,0,2.1,3.7c-.735-.213-1.494-.329-2.227-.548a1.317,1.317,0,0,1-1.085-1.614,29.833,29.833,0,0,0,.194-4.576A.664.664,0,0,0,204.256,411.7Z",
    transform: "translate(-19645.84 -639.585)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6741",
    "data-name": "Path 6741",
    d: "M202.995,416.713a1.317,1.317,0,0,0,1.085,1.614c.733.219,1.492.335,2.227.548.119.142.24.282.364.419-1.015-.245-2.041-.461-3.046-.746-.948-.269-1.017-.351-.986-1.366.054-1.726.168-3.451.257-5.175h0a.905.905,0,0,0,.293.13A29.836,29.836,0,0,1,202.995,416.713Z",
    transform: "translate(-19645.443 -639.754)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6742",
    "data-name": "Path 6742",
    d: "M204.48,411.43c.018.04.026.08.041.121a.664.664,0,0,1-.673.273c0-.049,0-.1,0-.149a2.1,2.1,0,0,0,.629-.245Z",
    transform: "translate(-19646.104 -639.441)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6743",
    "data-name": "Path 6743",
    d: "M203.5,412.114a.9.9,0,0,1-.293-.13,1.122,1.122,0,0,0,.295-.02C203.5,412.015,203.5,412.065,203.5,412.114Z",
    transform: "translate(-19645.758 -639.731)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6744",
    "data-name": "Path 6744",
    d: "M205.32,411.65l.034-.038a2.185,2.185,0,0,1,.534,2.019,3.126,3.126,0,0,0,.314,1.992,19.175,19.175,0,0,0,1.413,2.395,3.458,3.458,0,0,1,.473.739c-.107-.036-.215-.065-.323-.1a10.513,10.513,0,0,1-2.1-3.7C205.347,413.895,205.717,412.725,205.32,411.65Z",
    transform: "translate(-19646.902 -639.539)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6745",
    "data-name": "Path 6745",
    d: "M210.992,427.126a.807.807,0,0,1,.042.323c-.125-.137-.245-.277-.364-.419C210.777,427.061,210.885,427.089,210.992,427.126Z",
    transform: "translate(-19649.807 -647.909)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6746",
    "data-name": "Path 6746",
    d: "M205.23,411.43c.028.027.049.056.075.083l-.034.038C205.256,411.51,205.248,411.47,205.23,411.43Z",
    transform: "translate(-19646.854 -639.441)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6747",
    "data-name": "Path 6747",
    d: "M192.551,336.731a25.068,25.068,0,0,1-.2,4.7,1.9,1.9,0,0,0-1.7-.88c.022-.04.042-.081.065-.12.23-.81.571-1.579.853-2.37a3.851,3.851,0,0,0,.319-2.768,1.683,1.683,0,0,0,.871-.221A3.788,3.788,0,0,0,192.551,336.731Z",
    transform: "translate(-19638.939 -597.989)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6748",
    "data-name": "Path 6748",
    d: "M194.567,336.574a3.788,3.788,0,0,1,.2-1.66,1.108,1.108,0,0,0,.178-.133q-.006,2.839-.013,5.677c0,.4.068.84-.511.919-.02-.039-.043-.069-.064-.1A25.067,25.067,0,0,0,194.567,336.574Z",
    transform: "translate(-19640.953 -597.832)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6749",
    "data-name": "Path 6749",
    d: "M193.161,335.077a2.414,2.414,0,0,0-.162-.34,3.308,3.308,0,0,1,1.125-.025c-.033.048-.065.1-.092.144A1.684,1.684,0,0,1,193.161,335.077Z",
    transform: "translate(-19640.215 -597.775)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6750",
    "data-name": "Path 6750",
    d: "M195.436,334.767a1.11,1.11,0,0,1-.178.133c.027-.049.059-.1.092-.144l.086.011Z",
    transform: "translate(-19641.439 -597.818)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6751",
    "data-name": "Path 6751",
    d: "M191.661,335.554a3.851,3.851,0,0,1-.319,2.769c-.282.79-.623,1.56-.853,2.37-.023.039-.043.08-.065.12-.062,0-.124-.008-.187-.009a3.378,3.378,0,0,1,.437-1.742,7.115,7.115,0,0,0,.821-3.5C191.551,335.557,191.606,335.556,191.661,335.554Z",
    transform: "translate(-19638.715 -598.251)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6752",
    "data-name": "Path 6752",
    d: "M192.991,335.153c0-.113,0-.229,0-.343a2.409,2.409,0,0,1,.162.34C193.1,335.152,193.046,335.153,192.991,335.153Z",
    transform: "translate(-19640.207 -597.847)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6753",
    "data-name": "Path 6753",
    d: "M192.3,347.936c-.006.021-.009.043-.014.064l-1.721-.876.038-.068A1.9,1.9,0,0,1,192.3,347.936Z",
    transform: "translate(-19638.895 -604.495)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6754",
    "data-name": "Path 6754",
    d: "M194.345,348.98c.021.036.044.066.064.1l-.078-.04C194.336,349.023,194.339,349,194.345,348.98Z",
    transform: "translate(-19640.938 -605.539)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6755",
    "data-name": "Path 6755",
    d: "M190.388,347.113l-.15-.077c.063,0,.125.005.187.009Z",
    transform: "translate(-19638.717 -604.484)",
    fill: "#cfd7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6756",
    "data-name": "Path 6756",
    d: "M275.014,407.571a1.07,1.07,0,0,0-.678.751c-.146.374-.234.767-.358,1.148-.514,1.569-1.7,1.778-3.092,1.586a1.829,1.829,0,0,0-.751-1,84.788,84.788,0,0,0,.976-8.609,16.131,16.131,0,0,0,3.144,5.52A1.856,1.856,0,0,0,275.014,407.571Z",
    transform: "translate(-19682.09 -634.019)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6757",
    "data-name": "Path 6757",
    d: "M269.592,408.784l-.1-.084c-.245.291-.08.72-.347.96-.091-1.372.573-2.631.557-4.014-.013-1.225.312-2.45.37-3.682a13.937,13.937,0,0,1,.294-2.858,8.057,8.057,0,0,0,.2,1.068A84.754,84.754,0,0,1,269.592,408.784Z",
    transform: "translate(-19681.545 -632.751)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6758",
    "data-name": "Path 6758",
    d: "M274.87,416.746c.125-.381.213-.773.358-1.148a1.07,1.07,0,0,1,.678-.751,1.906,1.906,0,0,0,.329.106c-.539.069-.693.471-.8.919a9.192,9.192,0,0,1-.314,1.153,3.186,3.186,0,0,1-1.5,1.642c-.72.4-1.214-.217-1.825-.25a.821.821,0,0,0-.018-.084C273.169,418.524,274.355,418.315,274.87,416.746Z",
    transform: "translate(-19682.98 -641.296)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M276.382,406.78a.779.779,0,0,0-.209.021,1.856,1.856,0,0,1-.759-.608,16.129,16.129,0,0,1-3.144-5.52c.021-.215.043-.432.066-.648.052.138.091.283.138.428A16.16,16.16,0,0,0,276.382,406.78Z",
    transform: "translate(-19683.248 -633.249)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6760",
    "data-name": "Path 6760",
    d: "M281.017,414.8c.04.042.078.085.119.127a1.9,1.9,0,0,1-.329-.106A.782.782,0,0,1,281.017,414.8Z",
    transform: "translate(-19687.881 -641.27)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6761",
    "data-name": "Path 6761",
    d: "M272.029,400.175a8.052,8.052,0,0,1-.2-1.068,1.056,1.056,0,0,1,.269.42C272.072,399.743,272.051,399.96,272.029,400.175Z",
    transform: "translate(-19683.006 -632.751)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6762",
    "data-name": "Path 6762",
    d: "M260.976,432.4c-.176.288-.357.573-.56.847a1.08,1.08,0,0,1-1.352.48,1.255,1.255,0,0,1-.946-1.367,6.945,6.945,0,0,1,.452-1.9A4.379,4.379,0,0,0,260.976,432.4Z",
    transform: "translate(-19675.559 -649.771)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    d: "M257.734,432.177a1.255,1.255,0,0,0,.946,1.367,1.08,1.08,0,0,0,1.352-.48c.2-.273.385-.559.56-.847.071.028.141.059.214.085.006.459-.416.662-.595,1.005a1.022,1.022,0,0,1-1.252.662c-.613-.17-1.317-.353-1.468-1.077a3.182,3.182,0,0,1,.608-2.776c.027.056.059.1.086.157A6.945,6.945,0,0,0,257.734,432.177Z",
    transform: "translate(-19675.178 -649.585)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6764",
    "data-name": "Path 6764",
    d: "M261.52,432.326a4.379,4.379,0,0,1-2.406-1.944c.009-.022.016-.045.024-.066l2.42,1.954C261.546,432.288,261.532,432.306,261.52,432.326Z",
    transform: "translate(-19676.104 -649.692)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6765",
    "data-name": "Path 6765",
    d: "M259.011,430.274c-.028-.053-.06-.1-.086-.157.037.03.075.059.111.091C259.027,430.229,259.02,430.251,259.011,430.274Z",
    transform: "translate(-19676.002 -649.585)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6766",
    "data-name": "Path 6766",
    d: "M264.416,434.589l.176.142c-.073-.027-.143-.057-.213-.085C264.39,434.626,264.4,434.608,264.416,434.589Z",
    transform: "translate(-19678.961 -652.012)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    d: "M271.962,394.954c-.195.322,0,.714-.183,1.037C271.731,395.626,271.631,395.251,271.962,394.954Z",
    transform: "translate(-19682.953 -630.497)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6768",
    "data-name": "Path 6768",
    d: "M271.84,395.991c.184-.324-.011-.715.183-1.037A1.419,1.419,0,0,1,271.84,395.991Z",
    transform: "translate(-19683.014 -630.497)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6769",
    "data-name": "Path 6769",
    d: "M258.45,427.376c-.031-.356-.12-.726.213-1.006C258.435,426.672,258.681,427.074,258.45,427.376Z",
    transform: "translate(-19675.727 -647.551)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6770",
    "data-name": "Path 6770",
    d: "M258.491,427.376c.23-.3-.016-.7.213-1.006A1.357,1.357,0,0,1,258.491,427.376Z",
    transform: "translate(-19675.766 -647.551)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    d: "M259.56,416.908c.172-.239.042-.55.19-.794A.711.711,0,0,1,259.56,416.908Z",
    transform: "translate(-19676.35 -641.983)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    "data-name": "Path 6772",
    d: "M259.732,416.114c-.148.244-.018.555-.19.794A.9.9,0,0,1,259.732,416.114Z",
    transform: "translate(-19676.328 -641.983)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    d: "M257.4,425.889a.336.336,0,0,0,.209-.141.436.436,0,0,1-.219.521h0A.615.615,0,0,0,257.4,425.889Z",
    transform: "translate(-19675.174 -647.213)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    "data-name": "Path 6774",
    d: "M257.06,425.854c-.011.041-.023.082-.036.124-.035-.085-.069-.171-.1-.256A.331.331,0,0,0,257.06,425.854Z",
    transform: "translate(-19674.916 -647.199)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    "data-name": "Path 6775",
    d: "M257.271,426.031a.615.615,0,0,1-.01.38h0q-.056-.139-.113-.277c.013-.042.025-.083.036-.124A.174.174,0,0,0,257.271,426.031Z",
    transform: "translate(-19675.039 -647.356)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6776",
    "data-name": "Path 6776",
    d: "M257.323,425.733l.251.007a.337.337,0,0,1-.209.141A1.431,1.431,0,0,0,257.323,425.733Z",
    transform: "translate(-19675.133 -647.205)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    "data-name": "Path 6777",
    d: "M257.081,425.779c-.006.025-.014.05-.021.075a.331.331,0,0,1-.14-.132l.175.005C257.092,425.744,257.085,425.762,257.081,425.779Z",
    transform: "translate(-19674.916 -647.199)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6778",
    "data-name": "Path 6778",
    d: "M257.313,425.881a.174.174,0,0,1-.086-.021c.007-.025.015-.05.021-.075s.01-.035.014-.052h.009A1.432,1.432,0,0,1,257.313,425.881Z",
    transform: "translate(-19675.08 -647.205)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    "data-name": "Path 6779",
    d: "M259.216,423.707c-.178.244-.059.556-.188.811C258.965,424.219,258.93,423.926,259.216,423.707Z",
    transform: "translate(-19676.035 -646.105)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6780",
    "data-name": "Path 6780",
    d: "M259.078,424.518c.13-.255.01-.567.188-.811A.935.935,0,0,1,259.078,424.518Z",
    transform: "translate(-19676.084 -646.105)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    "data-name": "Path 6781",
    d: "M258,423.87c.149-.232,0-.538.189-.761A.706.706,0,0,1,258,423.87Z",
    transform: "translate(-19675.502 -645.781)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    "data-name": "Path 6782",
    d: "M258.174,423.109c-.185.223-.04.528-.189.761A.862.862,0,0,1,258.174,423.109Z",
    transform: "translate(-19675.484 -645.781)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    "data-name": "Path 6783",
    d: "M261.313,414.124c-.15.238-.02.544-.183.779C261.077,414.616,261.044,414.334,261.313,414.124Z",
    transform: "translate(-19677.18 -640.903)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    "data-name": "Path 6784",
    d: "M261.172,414.9c.163-.235.033-.541.183-.779A.874.874,0,0,1,261.172,414.9Z",
    transform: "translate(-19677.221 -640.903)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    "data-name": "Path 6785",
    d: "M260.109,414.252c.16-.24.034-.547.185-.789C260.349,413.753,260.384,414.039,260.109,414.252Z",
    transform: "translate(-19676.645 -640.544)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M259.712,421.578c-.155.232-.008.539-.192.762A.7.7,0,0,1,259.712,421.578Z",
    transform: "translate(-19676.309 -644.95)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M259.556,422.34c.184-.224.037-.53.192-.762A.868.868,0,0,1,259.556,422.34Z",
    transform: "translate(-19676.346 -644.95)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M258.485,421.695c.179-.239.049-.552.191-.8A.711.711,0,0,1,258.485,421.695Z",
    transform: "translate(-19675.764 -644.579)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M258.66,420.9c-.143.246-.013.56-.192.8A.912.912,0,0,1,258.66,420.9Z",
    transform: "translate(-19675.746 -644.579)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    "data-name": "Path 6790",
    d: "M260.779,416.785c-.155.234-.012.54-.19.768A.7.7,0,0,1,260.779,416.785Z",
    transform: "translate(-19676.889 -642.348)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    "data-name": "Path 6791",
    d: "M260.626,417.553c.178-.228.036-.534.19-.768A.873.873,0,0,1,260.626,417.553Z",
    transform: "translate(-19676.926 -642.348)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    "data-name": "Path 6792",
    d: "M260.275,418.915c-.186.232-.04.547-.2.785C260.021,419.408,259.994,419.122,260.275,418.915Z",
    transform: "translate(-19676.609 -643.504)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M260.114,419.7c.162-.238.016-.554.2-.785A.878.878,0,0,1,260.114,419.7Z",
    transform: "translate(-19676.646 -643.504)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M259.053,419.081c.162-.228.006-.538.2-.758A.7.7,0,0,1,259.053,419.081Z",
    transform: "translate(-19676.07 -643.182)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    d: "M259.232,418.323c-.192.22-.036.53-.2.758A.864.864,0,0,1,259.232,418.323Z",
    transform: "translate(-19676.051 -643.182)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    "data-name": "Path 6796",
    d: "M212.891,342.635c-.477,1.28-.291,2.7-.838,3.969a5.234,5.234,0,0,1-.753,1.691,12.944,12.944,0,0,1-3.238-5.163,2.7,2.7,0,0,0,.321-2.209c-.138-1.4-.215-2.8-.214-4.207a2.824,2.824,0,0,0-.421-1.642c1.458-.053,2.907.326,4.369.132q.263,3.188.524,6.376A2.313,2.313,0,0,0,212.891,342.635Z",
    transform: "translate(-19648.223 -597.988)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    "data-name": "Path 6797",
    d: "M207.6,334.728a1.983,1.983,0,0,0-.123-.166c1.489-.324,2.978.067,4.468,0,.008.1.016.2.024.3C210.509,335.054,209.06,334.676,207.6,334.728Z",
    transform: "translate(-19648.072 -597.642)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    "data-name": "Path 6798",
    d: "M211.6,357.279a5.233,5.233,0,0,0,.753-1.691c.547-1.271.361-2.689.838-3.969.017.029.027.059.048.087a2.636,2.636,0,0,0-.037.484c.181,1.717-.5,3.26-1.006,4.829-.268.824-.614.866-1.162.192-.613-.754-1.2-1.527-1.759-2.324a4.591,4.591,0,0,1-.976-2.693c.024-.026.04-.053.062-.078A12.944,12.944,0,0,0,211.6,357.279Z",
    transform: "translate(-19648.52 -606.973)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M208.242,340.842a2.7,2.7,0,0,1-.321,2.209c0-.005,0-.009-.005-.014l-.054-.016c.107-2.711-.261-5.4-.372-8.1l.08.074h.038a2.825,2.825,0,0,1,.421,1.642C208.027,338.041,208.1,339.44,208.242,340.842Z",
    transform: "translate(-19648.08 -597.907)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    "data-name": "Path 6800",
    d: "M207.564,334.883l-.08-.074c0-.031,0-.062-.005-.093a1.973,1.973,0,0,1,.123.166Z",
    transform: "translate(-19648.072 -597.797)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    d: "M208.359,352.671c-.022.026-.038.053-.062.078h0c0-.036,0-.073,0-.108l.054.016C208.355,352.662,208.358,352.666,208.359,352.671Z",
    transform: "translate(-19648.52 -607.526)",
    fill: "#e25959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6802",
    "data-name": "Path 6802",
    d: "M223.574,337.934a2.061,2.061,0,0,1-1.06,2.414,43.632,43.632,0,0,1-4.06,2.234c.256-1.419-.251-2.8-.226-4.215.016-.8-.179-1.6-.2-2.416a1.569,1.569,0,0,0-.154-.792c1.826-.232,3.663-.04,5.493-.124C222.969,336.014,223.425,336.992,223.574,337.934Z",
    transform: "translate(-19653.717 -597.97)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M223.029,334.593c-1.829.084-3.666-.108-5.493.124a.744.744,0,0,0-.284-.267,26.686,26.686,0,0,1,5.9-.131h0A2.187,2.187,0,0,0,223.029,334.593Z",
    transform: "translate(-19653.379 -597.527)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6804",
    "data-name": "Path 6804",
    d: "M224.1,340.135c-1.079.624-2.107,1.342-3.2,1.947a3.377,3.377,0,0,1-1.8.618c.009-.041.01-.08.018-.122a43.638,43.638,0,0,0,4.06-2.234,2.061,2.061,0,0,0,1.06-2.414c-.149-.942-.6-1.921-.207-2.9.038,0,.075,0,.113,0l.032,0c.075,1.276.3,2.534.487,3.8A1.116,1.116,0,0,1,224.1,340.135Z",
    transform: "translate(-19654.385 -597.966)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6805",
    "data-name": "Path 6805",
    d: "M230,334.708c-.037,0-.075,0-.113,0a2.181,2.181,0,0,1,.125-.273h0c0,.091.014.181.02.273Z",
    transform: "translate(-19660.238 -597.645)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6806",
    "data-name": "Path 6806",
    d: "M217.917,338.515c-.025,1.414.482,2.8.226,4.215-.022.01-.043.021-.065.032v0a2.314,2.314,0,0,1-.25-1.053q-.258-3.188-.524-6.376c.059-.007.119-.01.177-.021.028,0,.055,0,.083-.008a1.569,1.569,0,0,1,.154.792C217.738,336.911,217.933,337.717,217.917,338.515Z",
    transform: "translate(-19653.408 -598.117)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M217.536,334.989l-.083.008c-.059.01-.118.013-.177.021-.008-.1-.016-.2-.024-.3A.743.743,0,0,1,217.536,334.989Z",
    transform: "translate(-19653.379 -597.799)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M219,351.576c.022-.01.043-.022.065-.032-.008.041-.009.081-.018.122-.02-.028-.031-.058-.048-.087Z",
    transform: "translate(-19654.328 -606.931)",
    fill: "#d1d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    d: "M229.008,314.578c.005,1.073-.33,1.451-1.4,1.506-.412.022-.825-.006-1.239-.006a1.48,1.48,0,0,0-.716-.352,31.6,31.6,0,0,1-2.956-1.294,5.289,5.289,0,0,1-2.18-1.612c.277-.049.415-.314.605-.494,1.358-1.274,1.936-1.351,3.658-.54.6.284,1.154.761,1.9.631.032-.012.059-.018.09-.029.265.219.632.216.935.353A1.923,1.923,0,0,1,229.008,314.578Z",
    transform: "translate(-19655.152 -585.061)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M226.725,311.967c-.031.011-.059.017-.091.029-.747.13-1.3-.346-1.9-.631-1.722-.811-2.3-.734-3.658.54-.191.179-.329.445-.605.494-.013-.017-.027-.033-.039-.051,1.643-2.237,2.5-2.2,4.406-1.257a4.913,4.913,0,0,0,1.756.737h0A.77.77,0,0,0,226.725,311.967Z",
    transform: "translate(-19655.105 -584.641)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6811",
    "data-name": "Path 6811",
    d: "M233.62,322.58Z",
    transform: "translate(-19662.266 -591.208)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6812",
    "data-name": "Path 6812",
    d: "M236.285,316.45c-.152.87-.5,1.176-1.372,1.2-.485.013-.97.006-1.456.01a.619.619,0,0,0-.138-.355c.415,0,.827.027,1.239.006,1.068-.055,1.4-.433,1.4-1.506a1.923,1.923,0,0,0-1.3-1.838c-.3-.137-.67-.134-.935-.353.1-.037.2-.065.3-.1C235.8,313.765,236.581,314.764,236.285,316.45Z",
    transform: "translate(-19662.104 -586.291)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6813",
    "data-name": "Path 6813",
    d: "M234.042,313.565a.771.771,0,0,1-.132-.139c.151.009.294.025.432.044C234.243,313.5,234.145,313.528,234.042,313.565Z",
    transform: "translate(-19662.424 -586.239)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6814",
    "data-name": "Path 6814",
    d: "M222.659,316.288a31.612,31.612,0,0,0,2.956,1.294,1.479,1.479,0,0,1,.716.352c-.069,0-.137,0-.205,0-.161,0-.321,0-.482,0-1.262-.538-2.513-1.1-3.77-1.649-.82-.358-1.352-.724-1.428-1.6l.032-.006A5.289,5.289,0,0,0,222.659,316.288Z",
    transform: "translate(-19655.115 -586.918)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6815",
    "data-name": "Path 6815",
    d: "M220.438,314.622c0-.02-.006-.036-.007-.057.012.018.026.034.039.051Z",
    transform: "translate(-19655.105 -586.857)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6816",
    "data-name": "Path 6816",
    d: "M232.3,321.8c.068,0,.137,0,.205,0a.619.619,0,0,1,.138.355h0c-.277-.114-.549-.237-.824-.354C231.977,321.8,232.138,321.8,232.3,321.8Z",
    transform: "translate(-19661.289 -590.784)",
    fill: "#e59e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6817",
    "data-name": "Path 6817",
    d: "M212.37,300.727a49.6,49.6,0,0,1-.6-5.452c.279.271.629.367.875-.013a12.168,12.168,0,0,0,1.576-2.606c.219,2.386.59,4.757.754,7.149a12.306,12.306,0,0,0,.384,2.633.446.446,0,0,0,.033.052,33.441,33.441,0,0,0-2.89-1.7C212.458,300.77,212.415,300.747,212.37,300.727Z",
    transform: "translate(-19650.404 -574.964)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6818",
    "data-name": "Path 6818",
    d: "M218.27,300.982a12.308,12.308,0,0,1-.384-2.633c-.165-2.392-.535-4.763-.754-7.149a3.263,3.263,0,0,0,.181-1.226,4.117,4.117,0,0,1,.144.575q.553,5.33,1.094,10.659c-.08-.063-.166-.115-.248-.175A.44.44,0,0,1,218.27,300.982Z",
    transform: "translate(-19653.314 -573.508)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6819",
    "data-name": "Path 6819",
    d: "M213.081,310.311c.045.021.088.043.133.063a33.435,33.435,0,0,1,2.89,1.7.629.629,0,0,0,.084.123,13.535,13.535,0,0,1-3.059-1.6C213.11,310.5,213.1,310.408,213.081,310.311Z",
    transform: "translate(-19651.117 -584.548)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M219.778,314.289a.632.632,0,0,1-.084-.123c.082.059.168.112.248.175h0C219.886,314.326,219.833,314.306,219.778,314.289Z",
    transform: "translate(-19654.705 -586.641)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M211.74,294.6c-.008-.128-.018-.255-.027-.381.278.349.6.635.877.039.459-.978,1.135-1.846,1.551-2.846.015.19.033.379.049.569a12.166,12.166,0,0,1-1.576,2.606C212.368,294.967,212.018,294.871,211.74,294.6Z",
    transform: "translate(-19650.373 -574.288)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M217.024,290.631a5.3,5.3,0,0,0,.23-.657,3.263,3.263,0,0,1-.181,1.226C217.057,291.01,217.039,290.821,217.024,290.631Z",
    transform: "translate(-19653.256 -573.508)",
    fill: "#a9b4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    d: "M226.836,378.29c0-.075,0-.15,0-.227a5.829,5.829,0,0,1,.188-1.471,7.788,7.788,0,0,1,.048,1.913C227.044,378.543,226.861,378.253,226.836,378.29Z",
    transform: "translate(-19658.584 -620.529)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6824",
    "data-name": "Path 6824",
    d: "M226.841,382.806a.249.249,0,0,0-.176-.048,1.01,1.01,0,0,0,.139-.347C226.818,382.543,226.83,382.674,226.841,382.806Z",
    transform: "translate(-19658.49 -623.688)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6825",
    "data-name": "Path 6825",
    d: "M226.648,383.169a.249.249,0,0,1,.176.048c.006.071.015.141.02.212h0l-.211-.232h0C226.639,383.188,226.642,383.178,226.648,383.169Z",
    transform: "translate(-19658.473 -624.098)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6826",
    "data-name": "Path 6826",
    d: "M226.969,381.122a9.625,9.625,0,0,1,.112-1.085h.008l.1.017h0a2.878,2.878,0,0,1-.091,1.544.608.608,0,0,0-.093-.081C226.995,381.386,226.983,381.254,226.969,381.122Z",
    transform: "translate(-19658.656 -622.399)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    "data-name": "Path 6827",
    d: "M227.051,383.275a.6.6,0,0,1,.093.081,1.162,1.162,0,0,1-.073.131h0C227.066,383.416,227.057,383.346,227.051,383.275Z",
    transform: "translate(-19658.699 -624.157)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    "data-name": "Path 6828",
    d: "M226.647,380.306a8.238,8.238,0,0,0,.06.962,1.011,1.011,0,0,1-.139.347c-.006,0-.011,0-.017,0A1.974,1.974,0,0,1,226.647,380.306Z",
    transform: "translate(-19658.393 -622.545)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    d: "M226.644,383.171c-.006.009-.009.019-.015.028h0c0-.009,0-.019,0-.028S226.638,383.172,226.644,383.171Z",
    transform: "translate(-19658.471 -624.1)",
    fill: "#626ea3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6830",
    "data-name": "Path 6830",
    d: "M226.837,380.16a1.069,1.069,0,0,1,.079-.113l.093-.01a9.629,9.629,0,0,0-.112,1.085A8.248,8.248,0,0,1,226.837,380.16Z",
    transform: "translate(-19658.584 -622.399)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6831",
    "data-name": "Path 6831",
    d: "M227.091,376.342a1.325,1.325,0,0,1,.233-.007,1.125,1.125,0,0,0-.17.236A1.537,1.537,0,0,0,227.091,376.342Z",
    transform: "translate(-19658.721 -620.388)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6832",
    "data-name": "Path 6832",
    d: "M227.262,378.342s0-.009,0-.013a12.353,12.353,0,0,0-.007-1.275h.168a4.4,4.4,0,0,1-.08,1.381h0C227.32,378.376,227.292,378.35,227.262,378.342Z",
    transform: "translate(-19658.813 -620.779)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6833",
    "data-name": "Path 6833",
    d: "M227.243,376.666c0-.032-.009-.062-.015-.092a1.123,1.123,0,0,1,.17-.236c0,.109.007.218.012.327h-.168Z",
    transform: "translate(-19658.795 -620.391)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6834",
    "data-name": "Path 6834",
    d: "M227.074,377.056h.023c-.008.018-.017.035-.023.052C227.074,377.091,227.074,377.074,227.074,377.056Z",
    transform: "translate(-19658.713 -620.781)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6835",
    "data-name": "Path 6835",
    d: "M227.1,376.674h-.023c0-.107,0-.215.007-.321a1.536,1.536,0,0,1,.063.229A.835.835,0,0,0,227.1,376.674Z",
    transform: "translate(-19658.713 -620.399)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6836",
    "data-name": "Path 6836",
    d: "M227.172,376.854c.006.031.011.061.015.092h-.062A.832.832,0,0,1,227.172,376.854Z",
    transform: "translate(-19658.742 -620.671)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6837",
    "data-name": "Path 6837",
    d: "M227.213,379.948c.008-.026.014-.051.024-.076.029.008.058.034.085.092l-.1-.017Z",
    transform: "translate(-19658.787 -622.309)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6838",
    "data-name": "Path 6838",
    d: "M227.126,379.87c-.01.025-.016.05-.024.076l-.093.01C227.05,379.886,227.089,379.861,227.126,379.87Z",
    transform: "translate(-19658.676 -622.307)",
    fill: "#484d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6839",
    "data-name": "Path 6839",
    d: "M205.429,293.919s0,0,.006-.006c.524-.7,1.092-1.376,1.606-2.007a15.454,15.454,0,0,0,1.034,2.729c.011.017.025.032.038.048-.437.716-.035,1.5,0,2.228a7.357,7.357,0,0,0,.57,3.32,32.379,32.379,0,0,1-3.262-1.8c-.032-.016-.062-.034-.094-.052C206.48,296.53,206.488,294.847,205.429,293.919Z",
    transform: "translate(-19646.904 -574.557)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6840",
    "data-name": "Path 6840",
    d: "M205.253,306.125a32.366,32.366,0,0,0,3.262,1.8,3.208,3.208,0,0,0,.238.379,20.84,20.84,0,0,1-3.734-2h0c.049-.074.094-.147.139-.221C205.19,306.09,205.221,306.109,205.253,306.125Z",
    transform: "translate(-19646.74 -582.247)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6841",
    "data-name": "Path 6841",
    d: "M207.991,294.351c-.013-.016-.026-.031-.038-.048a15.454,15.454,0,0,1-1.034-2.729c-.514.631-1.082,1.3-1.606,2.007,0,0,0,0-.005.006a2.441,2.441,0,0,0-.207-.163h0c.623-.7.971-1.661,1.974-2.128.36.984.7,1.921,1.049,2.859h0A1.41,1.41,0,0,0,207.991,294.351Z",
    transform: "translate(-19646.781 -574.225)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6842",
    "data-name": "Path 6842",
    d: "M205.244,300.773l-.068-.037c.136-.489.267-.981.417-1.467a2.317,2.317,0,0,0-.322-2.557.411.411,0,0,1-.087-.226,1.6,1.6,0,0,0,.165-.176C206.408,297.238,206.4,298.921,205.244,300.773Z",
    transform: "translate(-19646.824 -576.947)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6843",
    "data-name": "Path 6843",
    d: "M205.158,306.028c-.045.074-.09.147-.139.221.025-.085.048-.171.072-.258Z",
    transform: "translate(-19646.74 -582.203)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6844",
    "data-name": "Path 6844",
    d: "M205.143,296.292c-.016-.111-.021-.233-.042-.339a2.447,2.447,0,0,1,.207.163A1.6,1.6,0,0,1,205.143,296.292Z",
    transform: "translate(-19646.781 -576.754)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6845",
    "data-name": "Path 6845",
    d: "M211.181,300.208c-.033-.727-.436-1.511,0-2.228a1.283,1.283,0,0,0,.159.185,49.579,49.579,0,0,0,.6,5.452c-.064-.028-.127-.059-.19-.09A7.357,7.357,0,0,1,211.181,300.208Z",
    transform: "translate(-19649.975 -577.854)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6846",
    "data-name": "Path 6846",
    d: "M212.856,310.2c.018.1.029.193.048.289a3.2,3.2,0,0,1-.238-.379C212.729,310.145,212.792,310.177,212.856,310.2Z",
    transform: "translate(-19650.893 -584.442)",
    fill: "#e25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6847",
    "data-name": "Path 6847",
    d: "M211.556,297.551h0c.008.127.018.254.027.381a1.283,1.283,0,0,1-.159-.185A1.407,1.407,0,0,1,211.556,297.551Z",
    transform: "translate(-19650.213 -577.621)",
    fill: "#e25a5a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/partnership.c146c780.svg";
export { ForwardRef as ReactComponent };